var items = {
  "block.minecraft.acacia_button": "دکمه اقاقيايی",
  "block.minecraft.acacia_door": "درب اقاقيا",
  "block.minecraft.acacia_fence": "نرده اقاقيا",
  "block.minecraft.acacia_fence_gate": "درب نرده اقاقيا",
  "block.minecraft.acacia_hanging_sign": "تابلو آويزان چوب اقاقيا",
  "block.minecraft.acacia_leaves": "برگ اقاقيا",
  "block.minecraft.acacia_log": "تنه درخت اقاقيا",
  "block.minecraft.acacia_planks": "الوار اقاقيا",
  "block.minecraft.acacia_pressure_plate": "صفحه فشاری اقاقيا",
  "block.minecraft.acacia_sapling": "نهال درخت اقاقيا",
  "block.minecraft.acacia_shelf": "قفسه کتاب اقاقيا",
  "block.minecraft.acacia_sign": "تابلو چوب اقاقيا",
  "block.minecraft.acacia_slab": "تخته اقاقيا",
  "block.minecraft.acacia_stairs": "پله اقاقيا",
  "block.minecraft.acacia_trapdoor": "دريچه‌ی اقاقيا",
  "block.minecraft.acacia_wall_hanging_sign": "تابلو آويزان ديوار چوب اقاقيا",
  "block.minecraft.acacia_wall_sign": "تابلو ديواری اقاقيا",
  "block.minecraft.acacia_wood": "چوب اقاقيا",
  "block.minecraft.activator_rail": "ريل فعالساز",
  "block.minecraft.air": "هوا",
  "block.minecraft.allium": "گل‌سير",
  "block.minecraft.amethyst_block": "بلوک ياقوت ارغوانی",
  "block.minecraft.amethyst_cluster": "خوشه ياقوت ارغوانی",
  "block.minecraft.ancient_debris": "عتيقه های باستانی",
  "block.minecraft.andesite": "آندزيت",
  "block.minecraft.andesite_slab": "نيمه آندزيت",
  "block.minecraft.andesite_stairs": "پله آندزيت",
  "block.minecraft.andesite_wall": "ديوار آندزيت",
  "block.minecraft.anvil": "سندان",
  "block.minecraft.attached_melon_stem": "ساقه هندوانه متصل",
  "block.minecraft.attached_pumpkin_stem": "ساقه کدو تنبل متصل",
  "block.minecraft.azalea": "آزالیا",
  "block.minecraft.azalea_leaves": "برگ های آزالیا",
  "block.minecraft.azure_bluet": "گل هاستونيا",
  "block.minecraft.bamboo": "بامبو",
  "block.minecraft.bamboo_block": "بلوک بامبو",
  "block.minecraft.bamboo_button": "دکمه بامبو",
  "block.minecraft.bamboo_door": "درب بامبو",
  "block.minecraft.bamboo_fence": "نرده بامبو",
  "block.minecraft.bamboo_fence_gate": "درب نرده بامبو",
  "block.minecraft.bamboo_hanging_sign": "تابلو آويزان چوب بامبو",
  "block.minecraft.bamboo_mosaic": "موزائيک بامبو",
  "block.minecraft.bamboo_mosaic_slab": "نيمه موزائيک بامبو",
  "block.minecraft.bamboo_mosaic_stairs": "پله موزائيک بامبو",
  "block.minecraft.bamboo_planks": "تخته چوب بامبو",
  "block.minecraft.bamboo_pressure_plate": "صفحه فشاری بامبو",
  "block.minecraft.bamboo_sapling": "نهال بامبو",
  "block.minecraft.bamboo_shelf": "قفسه کتاب بامبو",
  "block.minecraft.bamboo_sign": "تابلو بامبو",
  "block.minecraft.bamboo_slab": "نيمه بامبو",
  "block.minecraft.bamboo_stairs": "پله بامبو",
  "block.minecraft.bamboo_trapdoor": "دريچه‌ی بامبو",
  "block.minecraft.bamboo_wall_hanging_sign": "تابلو آويزان ديوار چوب بامبو",
  "block.minecraft.bamboo_wall_sign": "تابلوی ديواری بامبو",
  "block.minecraft.banner.base.black": "سطح کاملا سياه",
  "block.minecraft.banner.base.blue": "سطح کاملا آبی",
  "block.minecraft.banner.base.brown": "سطح کاملا قهوه‌ای",
  "block.minecraft.banner.base.cyan": "سطح کاملا فيروزه‌ای",
  "block.minecraft.banner.base.gray": "سطح کاملا خاکستری",
  "block.minecraft.banner.base.green": "سطح کاملا سبز",
  "block.minecraft.banner.base.light_blue": "سطح کاملا آبی روشن",
  "block.minecraft.banner.base.light_gray": "سطح کاملا نقره‌ای",
  "block.minecraft.banner.base.lime": "سطح کاملا سبز روشن",
  "block.minecraft.banner.base.magenta": "سطح کاملا ارغوانی",
  "block.minecraft.banner.base.orange": "سطح کاملا نارنجی",
  "block.minecraft.banner.base.pink": "سطح کاملا صورتی",
  "block.minecraft.banner.base.purple": "سطح کاملا بنفش",
  "block.minecraft.banner.base.red": "سطح کاملا قرمز",
  "block.minecraft.banner.base.white": "سطح کاملا سفيد",
  "block.minecraft.banner.base.yellow": "سطح کاملا زرد",
  "block.minecraft.banner.border.black": "حاشیه سياه",
  "block.minecraft.banner.border.blue": "حاشیه آبی",
  "block.minecraft.banner.border.brown": "حاشیه قهوه‌ای",
  "block.minecraft.banner.border.cyan": "حاشیه فيروزه ای",
  "block.minecraft.banner.border.gray": "حاشیه خاکستری",
  "block.minecraft.banner.border.green": "حاشیه سبز",
  "block.minecraft.banner.border.light_blue": "حاشیه آبی روشن",
  "block.minecraft.banner.border.light_gray": "حاشیه خاکستری روشن",
  "block.minecraft.banner.border.lime": "حاشیه سبز روشن",
  "block.minecraft.banner.border.magenta": "حاشیه ارغوانی",
  "block.minecraft.banner.border.orange": "حاشیه نارنجی",
  "block.minecraft.banner.border.pink": "حاشیه صورتی",
  "block.minecraft.banner.border.purple": "حاشیه بنفش",
  "block.minecraft.banner.border.red": "حاشیه قرمز",
  "block.minecraft.banner.border.white": "حاشیه سفيد",
  "block.minecraft.banner.border.yellow": "حاشیه زرد",
  "block.minecraft.banner.bricks.black": "ديوار آجری سياه",
  "block.minecraft.banner.bricks.blue": "ديوار آجری آبی",
  "block.minecraft.banner.bricks.brown": "ديوار آجری قهوه‌ای",
  "block.minecraft.banner.bricks.cyan": "ديوار آجری فيروزه ای",
  "block.minecraft.banner.bricks.gray": "ديوار آجری خاکستری",
  "block.minecraft.banner.bricks.green": "ديوار آجری سبز",
  "block.minecraft.banner.bricks.light_blue": "ديوار آجری آبی روشن",
  "block.minecraft.banner.bricks.light_gray": "ديوار آجری خاکستری روشن",
  "block.minecraft.banner.bricks.lime": "ديوار آجری سبز روشن",
  "block.minecraft.banner.bricks.magenta": "ديوار آجری ارغوانی",
  "block.minecraft.banner.bricks.orange": "ديوار آجری نارنجی",
  "block.minecraft.banner.bricks.pink": "ديوار آجری صورتی",
  "block.minecraft.banner.bricks.purple": "ديوار آجری بنفش",
  "block.minecraft.banner.bricks.red": "ديوار آجری قرمز",
  "block.minecraft.banner.bricks.white": "ديوار آجری سفيد",
  "block.minecraft.banner.bricks.yellow": "ديوار آجری زرد",
  "block.minecraft.banner.circle.black": "دايره مرکزی سياه",
  "block.minecraft.banner.circle.blue": "دايره مرکزی آبی",
  "block.minecraft.banner.circle.brown": "دايره مرکزی قهوه‌ای",
  "block.minecraft.banner.circle.cyan": "دايره مرکزی فيروزه ای",
  "block.minecraft.banner.circle.gray": "دايره مرکزی خاکستری",
  "block.minecraft.banner.circle.green": "دايره مرکزی سبز",
  "block.minecraft.banner.circle.light_blue": "دايره مرکزی آبی روشن",
  "block.minecraft.banner.circle.light_gray": "دايره مرکزی خاکستری روشن",
  "block.minecraft.banner.circle.lime": "دايره مرکزی سبز روشن",
  "block.minecraft.banner.circle.magenta": "دايره مرکزی ارغوانی",
  "block.minecraft.banner.circle.orange": "دايره مرکزی نارنجی",
  "block.minecraft.banner.circle.pink": "دايره مرکزی صورتی",
  "block.minecraft.banner.circle.purple": "دايره مرکزی بنفش",
  "block.minecraft.banner.circle.red": "دايره مرکزی قرمز",
  "block.minecraft.banner.circle.white": "دايره مرکزی سفيد",
  "block.minecraft.banner.circle.yellow": "دايره مرکزی زرد",
  "block.minecraft.banner.creeper.black": "کریپر سياه",
  "block.minecraft.banner.creeper.blue": "کریپر آبی",
  "block.minecraft.banner.creeper.brown": "کریپر قهوه‌ای",
  "block.minecraft.banner.creeper.cyan": "کریپر فيروزه ای",
  "block.minecraft.banner.creeper.gray": "کریپر خاکستری",
  "block.minecraft.banner.creeper.green": "کریپر سبز",
  "block.minecraft.banner.creeper.light_blue": "کریپر آبی روشن",
  "block.minecraft.banner.creeper.light_gray": "کریپر خاکستری روشن",
  "block.minecraft.banner.creeper.lime": "کریپر سبز روشن",
  "block.minecraft.banner.creeper.magenta": "کریپر ارغوانی",
  "block.minecraft.banner.creeper.orange": "کریپر نارنجی",
  "block.minecraft.banner.creeper.pink": "کریپر صورتی",
  "block.minecraft.banner.creeper.purple": "کریپر بنفش",
  "block.minecraft.banner.creeper.red": "کریپر قرمز",
  "block.minecraft.banner.creeper.white": "کریپر سفيد",
  "block.minecraft.banner.creeper.yellow": "کریپر زرد",
  "block.minecraft.banner.cross.black": "ضربدر سياه",
  "block.minecraft.banner.cross.blue": "ضربدر آبی",
  "block.minecraft.banner.cross.brown": "ضربدر قهوه‌ای",
  "block.minecraft.banner.cross.cyan": "ضربدر فيروزه ای",
  "block.minecraft.banner.cross.gray": "ضربدر خاکستری",
  "block.minecraft.banner.cross.green": "ضربدر سبز",
  "block.minecraft.banner.cross.light_blue": "ضربدر آبی روشن",
  "block.minecraft.banner.cross.light_gray": "ضربدر خاکستری روشن",
  "block.minecraft.banner.cross.lime": "ضربدر سبز روشن",
  "block.minecraft.banner.cross.magenta": "ضربدر ارغوانی",
  "block.minecraft.banner.cross.orange": "ضربدر نارنجی",
  "block.minecraft.banner.cross.pink": "ضربدر صورتی",
  "block.minecraft.banner.cross.purple": "ضربدر بنفش",
  "block.minecraft.banner.cross.red": "ضربدر قرمز",
  "block.minecraft.banner.cross.white": "ضربدر سفيد",
  "block.minecraft.banner.cross.yellow": "ضربدر زرد",
  "block.minecraft.banner.curly_border.black": "حاشیه موّاج سياه",
  "block.minecraft.banner.curly_border.blue": "حاشیه موّاج آبی",
  "block.minecraft.banner.curly_border.brown": "حاشیه موّاج قهوه‌ای",
  "block.minecraft.banner.curly_border.cyan": "حاشیه موّاج فيروزه ای",
  "block.minecraft.banner.curly_border.gray": "حاشیه موّاج خاکستری",
  "block.minecraft.banner.curly_border.green": "حاشیه موّاج سبز",
  "block.minecraft.banner.curly_border.light_blue": "حاشیه موّاج آبی روشن",
  "block.minecraft.banner.curly_border.light_gray": "حاشیه موّاج خاکستری روشن",
  "block.minecraft.banner.curly_border.lime": "حاشیه موّاج سبز روشن",
  "block.minecraft.banner.curly_border.magenta": "حاشیه موّاج ارغوانی",
  "block.minecraft.banner.curly_border.orange": "حاشیه موّاج نارنجی",
  "block.minecraft.banner.curly_border.pink": "حاشیه موّاج صورتی",
  "block.minecraft.banner.curly_border.purple": "حاشیه موّاج بنفش",
  "block.minecraft.banner.curly_border.red": "حاشیه موّاج قرمز",
  "block.minecraft.banner.curly_border.white": "حاشیه موّاج سفيد",
  "block.minecraft.banner.curly_border.yellow": "حاشیه موّاج زرد",
  "block.minecraft.banner.diagonal_left.black": "مورب پرشده بالا-چپ سياه",
  "block.minecraft.banner.diagonal_left.blue": "مورب پرشده بالا-چپ آبی",
  "block.minecraft.banner.diagonal_left.brown": "مورب پرشده بالا-چپ قهوه‌ای",
  "block.minecraft.banner.diagonal_left.cyan": "مورب پرشده بالا-چپ فيروزه ای",
  "block.minecraft.banner.diagonal_left.gray": "مورب پرشده بالا-چپ خاکستری",
  "block.minecraft.banner.diagonal_left.green": "مورب پرشده بالا-چپ سبز",
  "block.minecraft.banner.diagonal_left.light_blue": "مورب پرشده بالا-چپ آبی روشن",
  "block.minecraft.banner.diagonal_left.light_gray": "مورب پرشده بالا-چپ خاکستری روشن",
  "block.minecraft.banner.diagonal_left.lime": "مورب پرشده بالا-چپ سبز روشن",
  "block.minecraft.banner.diagonal_left.magenta": "مورب پرشده بالا-چپ ارغوانی",
  "block.minecraft.banner.diagonal_left.orange": "مورب پرشده بالا-چپ نارنجی",
  "block.minecraft.banner.diagonal_left.pink": "مورب پرشده بالا-چپ صورتی",
  "block.minecraft.banner.diagonal_left.purple": "مورب پيچ بنفشمورب پرشده بالا-چپ بنفش",
  "block.minecraft.banner.diagonal_left.red": "مورب پرشده بالا-چپ قرمز",
  "block.minecraft.banner.diagonal_left.white": "مورب پرشده بالا-چپ سفيد",
  "block.minecraft.banner.diagonal_left.yellow": "مورب پرشده بالا-چپ زرد",
  "block.minecraft.banner.diagonal_right.black": "مورب پرشده بالا-راست سياه",
  "block.minecraft.banner.diagonal_right.blue": "مورب پرشده بالا-راست آبی",
  "block.minecraft.banner.diagonal_right.brown": "مورب پرشده بالا-راست قهوه‌ای",
  "block.minecraft.banner.diagonal_right.cyan": "مورب پرشده بالا-راست فيروزه ای",
  "block.minecraft.banner.diagonal_right.gray": "مورب پرشده بالا-راست خاکستری",
  "block.minecraft.banner.diagonal_right.green": "مورب پرشده بالا-راست سبز",
  "block.minecraft.banner.diagonal_right.light_blue": "مورب پرشده بالا-راست آبی روشن",
  "block.minecraft.banner.diagonal_right.light_gray": "مورب پرشده بالا-راست خاکستری روشن",
  "block.minecraft.banner.diagonal_right.lime": "مورب پرشده بالا-راست سبز روشن",
  "block.minecraft.banner.diagonal_right.magenta": "مورب پرشده بالا-راست ارغوانی",
  "block.minecraft.banner.diagonal_right.orange": "مورب پرشده بالا-راست نارنجی",
  "block.minecraft.banner.diagonal_right.pink": "مورب پرشده بالا-راست صورتی",
  "block.minecraft.banner.diagonal_right.purple": "مورب پرشده بالا-راست بنفش",
  "block.minecraft.banner.diagonal_right.red": "مورب پرشده بالا-راست قرمز",
  "block.minecraft.banner.diagonal_right.white": "مورب پرشده بالا-راست سفيد",
  "block.minecraft.banner.diagonal_right.yellow": "مورب پرشده بالا-راست زرد",
  "block.minecraft.banner.diagonal_up_left.black": "مورب پرشده پايين-چپ سياه",
  "block.minecraft.banner.diagonal_up_left.blue": "مورب پرشده پايين-چپ آبی",
  "block.minecraft.banner.diagonal_up_left.brown": "مورب پرشده پايين-چپ قهوه‌ای",
  "block.minecraft.banner.diagonal_up_left.cyan": "مورب پرشده پايين-چپ فيروزه‌ای",
  "block.minecraft.banner.diagonal_up_left.gray": "مورب پرشده پايين-چپ خاکستری",
  "block.minecraft.banner.diagonal_up_left.green": "مورب پرشده پايين-چپ سبز",
  "block.minecraft.banner.diagonal_up_left.light_blue": "مورب پرشده پايين-چپ آبی روشن",
  "block.minecraft.banner.diagonal_up_left.light_gray": "مورب پرشده پايين-چپ خاکستری روشن",
  "block.minecraft.banner.diagonal_up_left.lime": "مورب پرشده پايين-چپ سبز روشن",
  "block.minecraft.banner.diagonal_up_left.magenta": "مورب پرشده پايين-چپ ارغوانی",
  "block.minecraft.banner.diagonal_up_left.orange": "مورب پرشده پايين-چپ نارنجی",
  "block.minecraft.banner.diagonal_up_left.pink": "مورب پرشده پايين-چپ صورتی",
  "block.minecraft.banner.diagonal_up_left.purple": "مورب پرشده پايين-چپ بنفش",
  "block.minecraft.banner.diagonal_up_left.red": "مورب پرشده پايين-چپ قرمز",
  "block.minecraft.banner.diagonal_up_left.white": "مورب پرشده پايين-چپ سفيد",
  "block.minecraft.banner.diagonal_up_left.yellow": "مورب پرشده پايين-چپ زرد",
  "block.minecraft.banner.diagonal_up_right.black": "مورب پرشده پايين-راست سياه",
  "block.minecraft.banner.diagonal_up_right.blue": "مورب پرشده پايين-راست آبی",
  "block.minecraft.banner.diagonal_up_right.brown": "مورب پرشده پايين-راست قهوه‌ای",
  "block.minecraft.banner.diagonal_up_right.cyan": "مورب پرشده پايين-راست فيروزه ای",
  "block.minecraft.banner.diagonal_up_right.gray": "مورب پرشده پايين-راست خاکستری",
  "block.minecraft.banner.diagonal_up_right.green": "مورب پرشده پايين-راست سبز",
  "block.minecraft.banner.diagonal_up_right.light_blue": "مورب پرشده پايين-راست آبی روشن",
  "block.minecraft.banner.diagonal_up_right.light_gray": "مورب پرشده پايين-راست خاکستری روشن",
  "block.minecraft.banner.diagonal_up_right.lime": "مورب پرشده پايين-راست سبز روشن",
  "block.minecraft.banner.diagonal_up_right.magenta": "مورب پرشده پايين-راست ارغوانی",
  "block.minecraft.banner.diagonal_up_right.orange": "مورب پرشده پايين-راست نارنجی",
  "block.minecraft.banner.diagonal_up_right.pink": "مورب پرشده پايين-راست صورتی",
  "block.minecraft.banner.diagonal_up_right.purple": "مورب پرشده پايين-راست بنفش",
  "block.minecraft.banner.diagonal_up_right.red": "مورب پرشده پايين-راست قرمز",
  "block.minecraft.banner.diagonal_up_right.white": "مورب پرشده پايين-راست سفيد",
  "block.minecraft.banner.diagonal_up_right.yellow": "مورب پرشده پايين-راست زرد",
  "block.minecraft.banner.flow.black": "جريان سياه",
  "block.minecraft.banner.flow.blue": "جريان آبی",
  "block.minecraft.banner.flow.brown": "جريان قهوه‌ای",
  "block.minecraft.banner.flow.cyan": "جريان فیروزه ای",
  "block.minecraft.banner.flow.gray": "جريان خاکستری",
  "block.minecraft.banner.flow.green": "جريان سبز",
  "block.minecraft.banner.flow.light_blue": "جريان آبی روشن",
  "block.minecraft.banner.flow.light_gray": "جريان نقره‌ای",
  "block.minecraft.banner.flow.lime": "جريان سبز روشن",
  "block.minecraft.banner.flow.magenta": "جريان ارغوانی",
  "block.minecraft.banner.flow.orange": "جريان نارنجی",
  "block.minecraft.banner.flow.pink": "جريان صورتی",
  "block.minecraft.banner.flow.purple": "جريان بنفش",
  "block.minecraft.banner.flow.red": "جريان قرمز",
  "block.minecraft.banner.flow.white": "جريان سفيد",
  "block.minecraft.banner.flow.yellow": "جريان زرد",
  "block.minecraft.banner.flower.black": "گل سياه",
  "block.minecraft.banner.flower.blue": "گل آبی",
  "block.minecraft.banner.flower.brown": "گل قهوه ای",
  "block.minecraft.banner.flower.cyan": "گل فيروزه ای",
  "block.minecraft.banner.flower.gray": "گل خاکستری",
  "block.minecraft.banner.flower.green": "گل سبز",
  "block.minecraft.banner.flower.light_blue": "گل آبی روشن",
  "block.minecraft.banner.flower.light_gray": "گل خاکستری روشن",
  "block.minecraft.banner.flower.lime": "گل سبز روشن",
  "block.minecraft.banner.flower.magenta": "گل ارغوانی",
  "block.minecraft.banner.flower.orange": "گل نارنجی",
  "block.minecraft.banner.flower.pink": "گل صورتی",
  "block.minecraft.banner.flower.purple": "گل بنفش",
  "block.minecraft.banner.flower.red": "گل قرمز",
  "block.minecraft.banner.flower.white": "گل سفيد",
  "block.minecraft.banner.flower.yellow": "گل زرد",
  "block.minecraft.banner.globe.black": "کره مشکی",
  "block.minecraft.banner.globe.blue": "کره آبی",
  "block.minecraft.banner.globe.brown": "کره قهوه ای",
  "block.minecraft.banner.globe.cyan": "کره فيروزه ای",
  "block.minecraft.banner.globe.gray": "کره خاکستری",
  "block.minecraft.banner.globe.green": "کره سبز",
  "block.minecraft.banner.globe.light_blue": "کره آبی آسمانی",
  "block.minecraft.banner.globe.light_gray": "کره خاکستری روشن",
  "block.minecraft.banner.globe.lime": "کره سبز روشن",
  "block.minecraft.banner.globe.magenta": "کره ارغوانی",
  "block.minecraft.banner.globe.orange": "کره نارنجی",
  "block.minecraft.banner.globe.pink": "کره صورتی",
  "block.minecraft.banner.globe.purple": "کره بنفش",
  "block.minecraft.banner.globe.red": "کره قرمز",
  "block.minecraft.banner.globe.white": "کره سفيد",
  "block.minecraft.banner.globe.yellow": "کره زرد",
  "block.minecraft.banner.gradient.black": "افت شدت از بالا سياه",
  "block.minecraft.banner.gradient.blue": "افت شدت از بالا آبی",
  "block.minecraft.banner.gradient.brown": "افت شدت از بالا قهوه‌ای",
  "block.minecraft.banner.gradient.cyan": "افت شدت از بالا فيروزه ای",
  "block.minecraft.banner.gradient.gray": "افت شدت از بالا خاکستری",
  "block.minecraft.banner.gradient.green": "افت شدت از بالا سبز",
  "block.minecraft.banner.gradient.light_blue": "افت شدت از بالا آبی روشن",
  "block.minecraft.banner.gradient.light_gray": "افت شدت از بالا خاکستری روشن",
  "block.minecraft.banner.gradient.lime": "افت شدت از بالا سبز روشن",
  "block.minecraft.banner.gradient.magenta": "افت شدت از بالا ارغوانی",
  "block.minecraft.banner.gradient.orange": "افت شدت از بالا نارنجی",
  "block.minecraft.banner.gradient.pink": "افت شدت از بالا صورتی",
  "block.minecraft.banner.gradient.purple": "افت شدت از بالا بنفش",
  "block.minecraft.banner.gradient.red": "افت شدت از بالا قرمز",
  "block.minecraft.banner.gradient.white": "افت شدت از بالا سفيد",
  "block.minecraft.banner.gradient.yellow": "افت شدت از بالا زرد",
  "block.minecraft.banner.gradient_up.black": "افت شدت از پايين سياه",
  "block.minecraft.banner.gradient_up.blue": "افت شدت از پايين آبی",
  "block.minecraft.banner.gradient_up.brown": "افت شدت از پايين قهوه‌ای",
  "block.minecraft.banner.gradient_up.cyan": "افت شدت از پايين فيروزه ای",
  "block.minecraft.banner.gradient_up.gray": "افت شدت از پايين خاکستری",
  "block.minecraft.banner.gradient_up.green": "افت شدت از پايين سبز",
  "block.minecraft.banner.gradient_up.light_blue": "افت شدت از پايين آبی روشن",
  "block.minecraft.banner.gradient_up.light_gray": "افت شدت از پايين خاکستری روشن",
  "block.minecraft.banner.gradient_up.lime": "افت شدت از پايين سبز روشن",
  "block.minecraft.banner.gradient_up.magenta": "افت شدت از پايين ارغوانی",
  "block.minecraft.banner.gradient_up.orange": "افت شدت از پايين نارنجی",
  "block.minecraft.banner.gradient_up.pink": "افت شدت از پايين صورتی",
  "block.minecraft.banner.gradient_up.purple": "افت شدت از پايين بنفش",
  "block.minecraft.banner.gradient_up.red": "افت شدت از پايين قرمز",
  "block.minecraft.banner.gradient_up.white": "افت شدت از پايين سفيد",
  "block.minecraft.banner.gradient_up.yellow": "افت شدت از پايين زرد",
  "block.minecraft.banner.guster.black": "گاستر سياه",
  "block.minecraft.banner.guster.blue": "گاستر آبی",
  "block.minecraft.banner.guster.brown": "گاستر قهوه‌ای",
  "block.minecraft.banner.guster.cyan": "گاستر فیروزه ای",
  "block.minecraft.banner.guster.gray": "گاستر خاکستری",
  "block.minecraft.banner.guster.green": "گاستر سبز",
  "block.minecraft.banner.guster.light_blue": "گاستر آبی روشن",
  "block.minecraft.banner.guster.light_gray": "گاستر نقره‌ای",
  "block.minecraft.banner.guster.lime": "گاستر سبز روشن",
  "block.minecraft.banner.guster.magenta": "گاستر ارغوانی",
  "block.minecraft.banner.guster.orange": "گاستر نارنجی",
  "block.minecraft.banner.guster.pink": "گاستر صورتی",
  "block.minecraft.banner.guster.purple": "گاستر بنفش",
  "block.minecraft.banner.guster.red": "گاستر قرمز",
  "block.minecraft.banner.guster.white": "گاستر سفيد",
  "block.minecraft.banner.guster.yellow": "گاستر زرد",
  "block.minecraft.banner.half_horizontal.black": "نيمه افقی بالايی سياه",
  "block.minecraft.banner.half_horizontal.blue": "نيمه افقی بالايی آبی",
  "block.minecraft.banner.half_horizontal.brown": "نيمه افقی بالايی قهوه‌ای",
  "block.minecraft.banner.half_horizontal.cyan": "نيمه افقی بالايی فيروزه ای",
  "block.minecraft.banner.half_horizontal.gray": "نيمه افقی بالايی خاکستری",
  "block.minecraft.banner.half_horizontal.green": "نيمه افقی بالايی سبز",
  "block.minecraft.banner.half_horizontal.light_blue": "نيمه افقی بالايی آبی روشن",
  "block.minecraft.banner.half_horizontal.light_gray": "نيمه افقی بالايی خاکستری روشن",
  "block.minecraft.banner.half_horizontal.lime": "نيمه افقی بالايی سبز روشن",
  "block.minecraft.banner.half_horizontal.magenta": "نيمه افقی بالايی ارغوانی",
  "block.minecraft.banner.half_horizontal.orange": "نيمه افقی بالايی نارنجی",
  "block.minecraft.banner.half_horizontal.pink": "نيمه افقی بالايی صورتی",
  "block.minecraft.banner.half_horizontal.purple": "نيمه افقی بالايی بنفش",
  "block.minecraft.banner.half_horizontal.red": "نيمه افقی بالايی قرمز",
  "block.minecraft.banner.half_horizontal.white": "نيمه افقی بالايی سفيد",
  "block.minecraft.banner.half_horizontal.yellow": "نيمه افقی بالايی زرد",
  "block.minecraft.banner.half_horizontal_bottom.black": "نيمه افقی پايين سياه",
  "block.minecraft.banner.half_horizontal_bottom.blue": "نيمه افقی پايين آبی",
  "block.minecraft.banner.half_horizontal_bottom.brown": "نيمه افقی پايين قهوه‌ای",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "نيمه افقی پايين فيروزه ای",
  "block.minecraft.banner.half_horizontal_bottom.gray": "نيمه افقی پايين خاکستری",
  "block.minecraft.banner.half_horizontal_bottom.green": "نيمه افقی پايين سبز",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "نيمه افقی پايين آبی روشن",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "نيمه افقی پايين خاکستری روشن",
  "block.minecraft.banner.half_horizontal_bottom.lime": "نيمه افقی پايين سبز روشن",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "نيمه افقی پايين ارغوانی",
  "block.minecraft.banner.half_horizontal_bottom.orange": "نيمه افقی پايين نارنجی",
  "block.minecraft.banner.half_horizontal_bottom.pink": "نيمه افقی پايين صورتی",
  "block.minecraft.banner.half_horizontal_bottom.purple": "نيمه افقی پايين بنفش",
  "block.minecraft.banner.half_horizontal_bottom.red": "نيمه افقی پايين قرمز",
  "block.minecraft.banner.half_horizontal_bottom.white": "نيمه افقی پايين سفيد",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "نيمه افقی پايين زرد",
  "block.minecraft.banner.half_vertical.black": "نيمه عمودی چپ سياه",
  "block.minecraft.banner.half_vertical.blue": "نيمه عمودی چپ آبی",
  "block.minecraft.banner.half_vertical.brown": "نيمه عمودی چپ قهوه‌ای",
  "block.minecraft.banner.half_vertical.cyan": "نيمه عمودی چپ فيروزه ای",
  "block.minecraft.banner.half_vertical.gray": "نيمه عمودی چپ خاکستری",
  "block.minecraft.banner.half_vertical.green": "نيمه عمودی چپ سبز",
  "block.minecraft.banner.half_vertical.light_blue": "نيمه عمودی چپ آبی روشن",
  "block.minecraft.banner.half_vertical.light_gray": "نيمه عمودی چپ خاکستری روشن",
  "block.minecraft.banner.half_vertical.lime": "نيمه عمودی چپ سبز روشن",
  "block.minecraft.banner.half_vertical.magenta": "نيمه عمودی چپ ارغوانی",
  "block.minecraft.banner.half_vertical.orange": "نيمه عمودی چپ نارنجی",
  "block.minecraft.banner.half_vertical.pink": "نيمه عمودی چپ صورتی",
  "block.minecraft.banner.half_vertical.purple": "نيمه عمودی چپ بنفش",
  "block.minecraft.banner.half_vertical.red": "نيمه عمودی چپ قرمز",
  "block.minecraft.banner.half_vertical.white": "نيمه عمودی چپ سفيد",
  "block.minecraft.banner.half_vertical.yellow": "نيمه عمودی چپ زرد",
  "block.minecraft.banner.half_vertical_right.black": "نيمه عمودی راست سياه",
  "block.minecraft.banner.half_vertical_right.blue": "نيمه عمودی راست آبی",
  "block.minecraft.banner.half_vertical_right.brown": "نيمه عمودی راست قهوه‌ای",
  "block.minecraft.banner.half_vertical_right.cyan": "نيمه عمودی راست فيروزه ای",
  "block.minecraft.banner.half_vertical_right.gray": "نيمه عمودی راست خاکستری",
  "block.minecraft.banner.half_vertical_right.green": "نيمه عمودی راست سبز",
  "block.minecraft.banner.half_vertical_right.light_blue": "نيمه عمودی راست آبی روشن",
  "block.minecraft.banner.half_vertical_right.light_gray": "نيمه عمودی راست خاکستری روشن",
  "block.minecraft.banner.half_vertical_right.lime": "نيمه عمودی راست سبز روشن",
  "block.minecraft.banner.half_vertical_right.magenta": "نيمه عمودی راست ارغوانی",
  "block.minecraft.banner.half_vertical_right.orange": "نيمه عمودی راست نارنجی",
  "block.minecraft.banner.half_vertical_right.pink": "نيمه عمودی راست صورتی",
  "block.minecraft.banner.half_vertical_right.purple": "نيمه عمودی راست بنفش",
  "block.minecraft.banner.half_vertical_right.red": "نيمه عمودی راست قرمز",
  "block.minecraft.banner.half_vertical_right.white": "نيمه عمودی راست سفيد",
  "block.minecraft.banner.half_vertical_right.yellow": "نيمه عمودی راست زرد",
  "block.minecraft.banner.mojang.black": "چيز سياه",
  "block.minecraft.banner.mojang.blue": "چيز آبی",
  "block.minecraft.banner.mojang.brown": "چيز قهوه ای",
  "block.minecraft.banner.mojang.cyan": "چيز فيروزه ای",
  "block.minecraft.banner.mojang.gray": "چيز خاکستری",
  "block.minecraft.banner.mojang.green": "چيز سبز",
  "block.minecraft.banner.mojang.light_blue": "چيز آبی روشن",
  "block.minecraft.banner.mojang.light_gray": "چيز نقره‌ای",
  "block.minecraft.banner.mojang.lime": "چيز سبز روشن",
  "block.minecraft.banner.mojang.magenta": "چيز ارغوانی",
  "block.minecraft.banner.mojang.orange": "چيز نارنجی",
  "block.minecraft.banner.mojang.pink": "چيز صورتی",
  "block.minecraft.banner.mojang.purple": "چيز بنفش",
  "block.minecraft.banner.mojang.red": "چيز قرمز",
  "block.minecraft.banner.mojang.white": "چيز سفيد",
  "block.minecraft.banner.mojang.yellow": "چيز زرد",
  "block.minecraft.banner.piglin.black": "پوزه سياه",
  "block.minecraft.banner.piglin.blue": "پوزه آبی",
  "block.minecraft.banner.piglin.brown": "پوزه قهوه ای",
  "block.minecraft.banner.piglin.cyan": "پوزه فيروزه ای",
  "block.minecraft.banner.piglin.gray": "پوزه خاکستری",
  "block.minecraft.banner.piglin.green": "پوزه سبز",
  "block.minecraft.banner.piglin.light_blue": "پوزه آبی روشن",
  "block.minecraft.banner.piglin.light_gray": "پوزه خاکستری روشن",
  "block.minecraft.banner.piglin.lime": "پوزه سبز روشن",
  "block.minecraft.banner.piglin.magenta": "پوزه ارغوانی",
  "block.minecraft.banner.piglin.orange": "پوزه نارنجی",
  "block.minecraft.banner.piglin.pink": "پوزه صورتی",
  "block.minecraft.banner.piglin.purple": "پوزه بنفش",
  "block.minecraft.banner.piglin.red": "پوزه قرمز",
  "block.minecraft.banner.piglin.white": "پوزه سفيد",
  "block.minecraft.banner.piglin.yellow": "پوزه زرد",
  "block.minecraft.banner.rhombus.black": "لوزی سياه",
  "block.minecraft.banner.rhombus.blue": "لوزی آبی",
  "block.minecraft.banner.rhombus.brown": "لوزی قهوه‌ای",
  "block.minecraft.banner.rhombus.cyan": "لوزی فيروزه ای",
  "block.minecraft.banner.rhombus.gray": "لوزی خاکستری",
  "block.minecraft.banner.rhombus.green": "لوزی سبز",
  "block.minecraft.banner.rhombus.light_blue": "لوزی آبی روشن",
  "block.minecraft.banner.rhombus.light_gray": "لوزی خاکستری روشن",
  "block.minecraft.banner.rhombus.lime": "لوزی سبز روشن",
  "block.minecraft.banner.rhombus.magenta": "لوزی ارغوانی",
  "block.minecraft.banner.rhombus.orange": "لوزی نارنجی",
  "block.minecraft.banner.rhombus.pink": "لوزی صورتی",
  "block.minecraft.banner.rhombus.purple": "لوزی بنفش",
  "block.minecraft.banner.rhombus.red": "لوزی قرمز",
  "block.minecraft.banner.rhombus.white": "لوزی سفيد",
  "block.minecraft.banner.rhombus.yellow": "لوزی زرد",
  "block.minecraft.banner.skull.black": "جمجمه سياه",
  "block.minecraft.banner.skull.blue": "جمجمه آبی",
  "block.minecraft.banner.skull.brown": "جمجمه قهوه‌ای",
  "block.minecraft.banner.skull.cyan": "جمجمه فيروزه‌ای",
  "block.minecraft.banner.skull.gray": "جمجمه خاکستری",
  "block.minecraft.banner.skull.green": "جمجمه سبز",
  "block.minecraft.banner.skull.light_blue": "جمجمه آبی روشن",
  "block.minecraft.banner.skull.light_gray": "جمجمه نقره‌ای",
  "block.minecraft.banner.skull.lime": "جمجمه سبز روشن",
  "block.minecraft.banner.skull.magenta": "جمجمه ارغوانی",
  "block.minecraft.banner.skull.orange": "جمجمه نارنجی",
  "block.minecraft.banner.skull.pink": "جمجمه صورتی",
  "block.minecraft.banner.skull.purple": "جمجمه بنفش",
  "block.minecraft.banner.skull.red": "جمجمه قرمز",
  "block.minecraft.banner.skull.white": "جمجمه سفيد",
  "block.minecraft.banner.skull.yellow": "جمجمه زرد",
  "block.minecraft.banner.small_stripes.black": "راه راه سياه",
  "block.minecraft.banner.small_stripes.blue": "راه راه آبی",
  "block.minecraft.banner.small_stripes.brown": "راه راه قهوه‌ای",
  "block.minecraft.banner.small_stripes.cyan": "راه راه فيروزه ای",
  "block.minecraft.banner.small_stripes.gray": "راه راه خاکستری",
  "block.minecraft.banner.small_stripes.green": "راه راه سبز",
  "block.minecraft.banner.small_stripes.light_blue": "راه راه آبی روشن",
  "block.minecraft.banner.small_stripes.light_gray": "راه راه خاکستری روشن",
  "block.minecraft.banner.small_stripes.lime": "راه راه سبز روشن",
  "block.minecraft.banner.small_stripes.magenta": "راه راه ارغوانی",
  "block.minecraft.banner.small_stripes.orange": "راه راه نارنجی",
  "block.minecraft.banner.small_stripes.pink": "راه راه صورتی",
  "block.minecraft.banner.small_stripes.purple": "راه راه بنفش",
  "block.minecraft.banner.small_stripes.red": "راه راه قرمز",
  "block.minecraft.banner.small_stripes.white": "راه راه سفيد",
  "block.minecraft.banner.small_stripes.yellow": "راه راه زرد",
  "block.minecraft.banner.square_bottom_left.black": "گوشه چپ پايين سياه",
  "block.minecraft.banner.square_bottom_left.blue": "گوشه چپ پايين آبی",
  "block.minecraft.banner.square_bottom_left.brown": "گوشه چپ پايين قهوه‌ای",
  "block.minecraft.banner.square_bottom_left.cyan": "گوشه چپ پايين فيروزه ای",
  "block.minecraft.banner.square_bottom_left.gray": "گوشه چپ پايين خاکستری",
  "block.minecraft.banner.square_bottom_left.green": "گوشه چپ پايين سبز",
  "block.minecraft.banner.square_bottom_left.light_blue": "گوشه چپ پايين آبی روشن",
  "block.minecraft.banner.square_bottom_left.light_gray": "گوشه چپ پايين خاکستری روشن",
  "block.minecraft.banner.square_bottom_left.lime": "گوشه چپ پايين سبز روشن",
  "block.minecraft.banner.square_bottom_left.magenta": "گوشه چپ پايين ارغوانی",
  "block.minecraft.banner.square_bottom_left.orange": "گوشه چپ پايين نارنجی",
  "block.minecraft.banner.square_bottom_left.pink": "گوشه چپ پايين صورتی",
  "block.minecraft.banner.square_bottom_left.purple": "گوشه چپ پايين بنفش",
  "block.minecraft.banner.square_bottom_left.red": "گوشه چپ پايين قرمز",
  "block.minecraft.banner.square_bottom_left.white": "گوشه چپ پايين سفيد",
  "block.minecraft.banner.square_bottom_left.yellow": "گوشه چپ پايين زرد",
  "block.minecraft.banner.square_bottom_right.black": "گوشه راست-پايين سياه",
  "block.minecraft.banner.square_bottom_right.blue": "گوشه راست-پايين آبی",
  "block.minecraft.banner.square_bottom_right.brown": "گوشه راست-پايين قهوه‌ای",
  "block.minecraft.banner.square_bottom_right.cyan": "گوشه راست-پايين فيروزه‌ای",
  "block.minecraft.banner.square_bottom_right.gray": "گوشه راست-پايين خاکستری",
  "block.minecraft.banner.square_bottom_right.green": "گوشه راست-پايين سبز",
  "block.minecraft.banner.square_bottom_right.light_blue": "گوشه راست-پايين آبی روشن",
  "block.minecraft.banner.square_bottom_right.light_gray": "گوشه راست-پايين نقره‌ای",
  "block.minecraft.banner.square_bottom_right.lime": "گوشه راست-پايين سبز روشن",
  "block.minecraft.banner.square_bottom_right.magenta": "گوشه راست-پايين ارغوانی",
  "block.minecraft.banner.square_bottom_right.orange": "گوشه راست-پايين نارنجی",
  "block.minecraft.banner.square_bottom_right.pink": "گوشه راست-پايين صورتی",
  "block.minecraft.banner.square_bottom_right.purple": "گوشه راست-پايين بنفش",
  "block.minecraft.banner.square_bottom_right.red": "گوشه راست-پايين قرمز",
  "block.minecraft.banner.square_bottom_right.white": "گوشه راست-پايين سفيد",
  "block.minecraft.banner.square_bottom_right.yellow": "گوشه راست-پايين زرد",
  "block.minecraft.banner.square_top_left.black": "گوشه چپ-بالا سياه",
  "block.minecraft.banner.square_top_left.blue": "گوشه چپ-بالا آبی",
  "block.minecraft.banner.square_top_left.brown": "گوشه چپ-بالا قهوه‌ای",
  "block.minecraft.banner.square_top_left.cyan": "گوشه چپ-بالا فيروزه‌ای",
  "block.minecraft.banner.square_top_left.gray": "گوشه چپ-بالا خاکستری",
  "block.minecraft.banner.square_top_left.green": "گوشه چپ-بالا سبز",
  "block.minecraft.banner.square_top_left.light_blue": "گوشه چپ-بالا آبی روشن",
  "block.minecraft.banner.square_top_left.light_gray": "گوشه چپ-بالا نقره‌ای",
  "block.minecraft.banner.square_top_left.lime": "گوشه چپ-بالا سبز روشن",
  "block.minecraft.banner.square_top_left.magenta": "گوشه چپ-بالا ارغوانی",
  "block.minecraft.banner.square_top_left.orange": "گوشه چپ-بالا نارنجی",
  "block.minecraft.banner.square_top_left.pink": "گوشه چپ-بالا صورتی",
  "block.minecraft.banner.square_top_left.purple": "گوشه چپ-بالا بنفش",
  "block.minecraft.banner.square_top_left.red": "گوشه چپ-بالا قرمز",
  "block.minecraft.banner.square_top_left.white": "گوشه چپ-بالا سفيد",
  "block.minecraft.banner.square_top_left.yellow": "گوشه چپ-بالا زرد",
  "block.minecraft.banner.square_top_right.black": "گوشه راست-بالا سياه",
  "block.minecraft.banner.square_top_right.blue": "گوشه راست-بالا آبی",
  "block.minecraft.banner.square_top_right.brown": "گوشه راست-بالا قهوه‌ای",
  "block.minecraft.banner.square_top_right.cyan": "گوشه راست-بالا فيروزه ای",
  "block.minecraft.banner.square_top_right.gray": "گوشه راست-بالا خاکستری",
  "block.minecraft.banner.square_top_right.green": "گوشه راست-بالا سبز",
  "block.minecraft.banner.square_top_right.light_blue": "گوشه راست-بالا آبی روشن",
  "block.minecraft.banner.square_top_right.light_gray": "گوشه راست-بالا خاکستری روشن",
  "block.minecraft.banner.square_top_right.lime": "گوشه راست-بالا سبز روشن",
  "block.minecraft.banner.square_top_right.magenta": "گوشه راست-بالا ارغوانی",
  "block.minecraft.banner.square_top_right.orange": "گوشه راست-بالا نارنجی",
  "block.minecraft.banner.square_top_right.pink": "گوشه راست-بالا صورتی",
  "block.minecraft.banner.square_top_right.purple": "گوشه راست-بالا بنفش",
  "block.minecraft.banner.square_top_right.red": "گوشه راست-بالا قرمز",
  "block.minecraft.banner.square_top_right.white": "گوشه راست-بالا سفيد",
  "block.minecraft.banner.square_top_right.yellow": "گوشه راست-بالا زرد",
  "block.minecraft.banner.straight_cross.black": "متقاطع سياه",
  "block.minecraft.banner.straight_cross.blue": "متقاطع آبی",
  "block.minecraft.banner.straight_cross.brown": "متقاطع قهوه‌ای",
  "block.minecraft.banner.straight_cross.cyan": "متقاطع فيروزه ای",
  "block.minecraft.banner.straight_cross.gray": "متقاطع خاکستری",
  "block.minecraft.banner.straight_cross.green": "متقاطع سبز",
  "block.minecraft.banner.straight_cross.light_blue": "متقاطع آبی روشن",
  "block.minecraft.banner.straight_cross.light_gray": "متقاطع خاکستری روشن",
  "block.minecraft.banner.straight_cross.lime": "متقاطع سبز روشن",
  "block.minecraft.banner.straight_cross.magenta": "متقاطع ارغوانی",
  "block.minecraft.banner.straight_cross.orange": "متقاطع نارنجی",
  "block.minecraft.banner.straight_cross.pink": "متقاطع صورتی",
  "block.minecraft.banner.straight_cross.purple": "متقاطع بنفش",
  "block.minecraft.banner.straight_cross.red": "متقاطع قرمز",
  "block.minecraft.banner.straight_cross.white": "متقاطع سفيد",
  "block.minecraft.banner.straight_cross.yellow": "متقاطع زرد",
  "block.minecraft.banner.stripe_bottom.black": "پايه سياه",
  "block.minecraft.banner.stripe_bottom.blue": "پايه آبی",
  "block.minecraft.banner.stripe_bottom.brown": "پايه قهوه‌ای",
  "block.minecraft.banner.stripe_bottom.cyan": "پايه فيروزه ای",
  "block.minecraft.banner.stripe_bottom.gray": "پايه خاکستری",
  "block.minecraft.banner.stripe_bottom.green": "پايه سبز",
  "block.minecraft.banner.stripe_bottom.light_blue": "پايه آبی روشن",
  "block.minecraft.banner.stripe_bottom.light_gray": "پايه خاکستری روشن",
  "block.minecraft.banner.stripe_bottom.lime": "پايه سبز روشن",
  "block.minecraft.banner.stripe_bottom.magenta": "پايه ارغوانی",
  "block.minecraft.banner.stripe_bottom.orange": "پايه نارنجی",
  "block.minecraft.banner.stripe_bottom.pink": "پايه صورتی",
  "block.minecraft.banner.stripe_bottom.purple": "پايه بنفش",
  "block.minecraft.banner.stripe_bottom.red": "پايه قرمز",
  "block.minecraft.banner.stripe_bottom.white": "پايه سفيد",
  "block.minecraft.banner.stripe_bottom.yellow": "پايه زرد",
  "block.minecraft.banner.stripe_center.black": "نوار وسط سياه",
  "block.minecraft.banner.stripe_center.blue": "نوار وسط آبی",
  "block.minecraft.banner.stripe_center.brown": "نوار وسط قهوه‌ای",
  "block.minecraft.banner.stripe_center.cyan": "نوار وسط فيروزه ای",
  "block.minecraft.banner.stripe_center.gray": "نوار وسط خاکستری",
  "block.minecraft.banner.stripe_center.green": "نوار وسط سبز",
  "block.minecraft.banner.stripe_center.light_blue": "نوار وسط آبی روشن",
  "block.minecraft.banner.stripe_center.light_gray": "نوار وسط خاکستری روشن",
  "block.minecraft.banner.stripe_center.lime": "نوار وسط سبز روشن",
  "block.minecraft.banner.stripe_center.magenta": "نوار وسط ارغوانی",
  "block.minecraft.banner.stripe_center.orange": "نوار وسط نارنجی",
  "block.minecraft.banner.stripe_center.pink": "نوار وسط صورتی",
  "block.minecraft.banner.stripe_center.purple": "نوار وسط بنفش",
  "block.minecraft.banner.stripe_center.red": "نوار وسط قرمز",
  "block.minecraft.banner.stripe_center.white": "نوار وسط سفيد",
  "block.minecraft.banner.stripe_center.yellow": "نوار وسط زرد",
  "block.minecraft.banner.stripe_downleft.black": "خط مورب از بالا به چپ سياه",
  "block.minecraft.banner.stripe_downleft.blue": "خط مورب از بالا به چپ آبی",
  "block.minecraft.banner.stripe_downleft.brown": "خط مورب از بالا به چپ قهوه‌ای",
  "block.minecraft.banner.stripe_downleft.cyan": "خط مورب از بالا به چپ فيروزه ای",
  "block.minecraft.banner.stripe_downleft.gray": "خط مورب از بالا به چپ خاکستری",
  "block.minecraft.banner.stripe_downleft.green": "خط مورب از بالا به چپ سبز",
  "block.minecraft.banner.stripe_downleft.light_blue": "خط مورب از بالا به چپ آبی روشن",
  "block.minecraft.banner.stripe_downleft.light_gray": "خط مورب از بالا به چپ خاکستری روشن",
  "block.minecraft.banner.stripe_downleft.lime": "خط مورب از بالا به چپ سبز روشن",
  "block.minecraft.banner.stripe_downleft.magenta": "خط مورب از بالا به چپ ارغوانی",
  "block.minecraft.banner.stripe_downleft.orange": "خط مورب از بالا به چپ نارنجی",
  "block.minecraft.banner.stripe_downleft.pink": "خط مورب از بالا به چپ صورتی",
  "block.minecraft.banner.stripe_downleft.purple": "خط مورب از بالا به چپ بنفش",
  "block.minecraft.banner.stripe_downleft.red": "خط مورب از بالا به چپ قرمز",
  "block.minecraft.banner.stripe_downleft.white": "خط مورب از بالا به چپ سفيد",
  "block.minecraft.banner.stripe_downleft.yellow": "خط مورب از بالا به چپ زرد",
  "block.minecraft.banner.stripe_downright.black": "خط مورب از بالا به راست سياه",
  "block.minecraft.banner.stripe_downright.blue": "خط مورب از بالا به راست آبی",
  "block.minecraft.banner.stripe_downright.brown": "خط مورب از بالا به راست قهوه‌ای",
  "block.minecraft.banner.stripe_downright.cyan": "خط مورب از بالا به راست فيروزه ای",
  "block.minecraft.banner.stripe_downright.gray": "خط مورب از بالا به راست خاکستری",
  "block.minecraft.banner.stripe_downright.green": "خط مورب از بالا به راست سبز",
  "block.minecraft.banner.stripe_downright.light_blue": "خط مورب از بالا به راست آبی روشن",
  "block.minecraft.banner.stripe_downright.light_gray": "خط مورب از بالا به راست خاکستری روشن",
  "block.minecraft.banner.stripe_downright.lime": "خط مورب از بالا به راست سبز روشن",
  "block.minecraft.banner.stripe_downright.magenta": "خط مورب از بالا به راست ارغوانی",
  "block.minecraft.banner.stripe_downright.orange": "خط مورب از بالا به راست نارنجی",
  "block.minecraft.banner.stripe_downright.pink": "خط مورب از بالا به راست صورتی",
  "block.minecraft.banner.stripe_downright.purple": "خط مورب از بالا به راست بنفش",
  "block.minecraft.banner.stripe_downright.red": "خط مورب از بالا به راست قرمز",
  "block.minecraft.banner.stripe_downright.white": "خط مورب از بالا به راست سفيد",
  "block.minecraft.banner.stripe_downright.yellow": "خط مورب از بالا به راست زرد",
  "block.minecraft.banner.stripe_left.black": "نوار چپ سياه",
  "block.minecraft.banner.stripe_left.blue": "نوار چپ آبی",
  "block.minecraft.banner.stripe_left.brown": "نوار چپ قهوه‌ای",
  "block.minecraft.banner.stripe_left.cyan": "نوار چپ فيروزه ای",
  "block.minecraft.banner.stripe_left.gray": "نوار چپ خاکستری",
  "block.minecraft.banner.stripe_left.green": "نوار چپ سبز",
  "block.minecraft.banner.stripe_left.light_blue": "نوار چپ آبی روشن",
  "block.minecraft.banner.stripe_left.light_gray": "نوار چپ خاکستری روشن",
  "block.minecraft.banner.stripe_left.lime": "نوار چپ سبز روشن",
  "block.minecraft.banner.stripe_left.magenta": "نوار چپ ارغوانی",
  "block.minecraft.banner.stripe_left.orange": "نوار چپ نارنجی",
  "block.minecraft.banner.stripe_left.pink": "نوار چپ صورتی",
  "block.minecraft.banner.stripe_left.purple": "نوار چپ بنفش",
  "block.minecraft.banner.stripe_left.red": "نوار چپ قرمز",
  "block.minecraft.banner.stripe_left.white": "نوار چپ سفيد",
  "block.minecraft.banner.stripe_left.yellow": "نوار چپ زرد",
  "block.minecraft.banner.stripe_middle.black": "خط وسط سياه",
  "block.minecraft.banner.stripe_middle.blue": "خط وسط آبی",
  "block.minecraft.banner.stripe_middle.brown": "خط وسط قهوه‌ای",
  "block.minecraft.banner.stripe_middle.cyan": "خط وسط فيروزه ای",
  "block.minecraft.banner.stripe_middle.gray": "خط وسط خاکستری",
  "block.minecraft.banner.stripe_middle.green": "خط وسط سبز",
  "block.minecraft.banner.stripe_middle.light_blue": "خط وسط آبی روشن",
  "block.minecraft.banner.stripe_middle.light_gray": "خط وسط خاکستری روشن",
  "block.minecraft.banner.stripe_middle.lime": "خط وسط سبز روشن",
  "block.minecraft.banner.stripe_middle.magenta": "خط وسط ارغوانی",
  "block.minecraft.banner.stripe_middle.orange": "خط وسط نارنجی",
  "block.minecraft.banner.stripe_middle.pink": "خط وسط صورتی",
  "block.minecraft.banner.stripe_middle.purple": "خط وسط بنفش",
  "block.minecraft.banner.stripe_middle.red": "خط وسط قرمز",
  "block.minecraft.banner.stripe_middle.white": "خط وسط سفيد",
  "block.minecraft.banner.stripe_middle.yellow": "خط وسط زرد",
  "block.minecraft.banner.stripe_right.black": "نوار راست سياه",
  "block.minecraft.banner.stripe_right.blue": "نوار راست آبی",
  "block.minecraft.banner.stripe_right.brown": "نوار راست قهوه‌ای",
  "block.minecraft.banner.stripe_right.cyan": "نوار راست فيروزه ای",
  "block.minecraft.banner.stripe_right.gray": "نوار راست خاکستری",
  "block.minecraft.banner.stripe_right.green": "نوار راست سبز",
  "block.minecraft.banner.stripe_right.light_blue": "نوار راست آبی روشن",
  "block.minecraft.banner.stripe_right.light_gray": "نوار راست خاکستری روشن",
  "block.minecraft.banner.stripe_right.lime": "نوار راست سبز روشن",
  "block.minecraft.banner.stripe_right.magenta": "نوار راست ارغوانی",
  "block.minecraft.banner.stripe_right.orange": "نوار راست نارنجی",
  "block.minecraft.banner.stripe_right.pink": "نوار راست صورتی",
  "block.minecraft.banner.stripe_right.purple": "نوار راست بنفش",
  "block.minecraft.banner.stripe_right.red": "نوار راست قرمز",
  "block.minecraft.banner.stripe_right.white": "نوار راست سفيد",
  "block.minecraft.banner.stripe_right.yellow": "نوار راست زرد",
  "block.minecraft.banner.stripe_top.black": "خط بالا سياه",
  "block.minecraft.banner.stripe_top.blue": "خط بالا آبی",
  "block.minecraft.banner.stripe_top.brown": "خط بالا قهوه‌ای",
  "block.minecraft.banner.stripe_top.cyan": "خط بالا فيروزه ای",
  "block.minecraft.banner.stripe_top.gray": "خط بالا خاکستری",
  "block.minecraft.banner.stripe_top.green": "خط بالا سبز",
  "block.minecraft.banner.stripe_top.light_blue": "خط بالا آبی روشن",
  "block.minecraft.banner.stripe_top.light_gray": "خط بالا خاکستری روشن",
  "block.minecraft.banner.stripe_top.lime": "خط بالا سبز روشن",
  "block.minecraft.banner.stripe_top.magenta": "خط بالا ارغوانی",
  "block.minecraft.banner.stripe_top.orange": "خط بالا نارنجی",
  "block.minecraft.banner.stripe_top.pink": "خط بالا صورتی",
  "block.minecraft.banner.stripe_top.purple": "خط بالا بنفش",
  "block.minecraft.banner.stripe_top.red": "خط بالا قرمز",
  "block.minecraft.banner.stripe_top.white": "خط بالا سفيد",
  "block.minecraft.banner.stripe_top.yellow": "خط بالا زرد",
  "block.minecraft.banner.triangle_bottom.black": "مثلث پايين سياه",
  "block.minecraft.banner.triangle_bottom.blue": "مثلث پايين آبی",
  "block.minecraft.banner.triangle_bottom.brown": "مثلث پايين قهوه‌ای",
  "block.minecraft.banner.triangle_bottom.cyan": "مثلث پايين فيروزه ای",
  "block.minecraft.banner.triangle_bottom.gray": "مثلث پايين خاکستری",
  "block.minecraft.banner.triangle_bottom.green": "مثلث پايين سبز",
  "block.minecraft.banner.triangle_bottom.light_blue": "مثلث پايين آبی روشن",
  "block.minecraft.banner.triangle_bottom.light_gray": "مثلث پايين خاکستری روشن",
  "block.minecraft.banner.triangle_bottom.lime": "مثلث پايين سبز روشن",
  "block.minecraft.banner.triangle_bottom.magenta": "مثلث پايين ارغوانی",
  "block.minecraft.banner.triangle_bottom.orange": "مثلث پايين نارنجی",
  "block.minecraft.banner.triangle_bottom.pink": "مثلث پايين صورتی",
  "block.minecraft.banner.triangle_bottom.purple": "مثلث پايين بنفش",
  "block.minecraft.banner.triangle_bottom.red": "مثلث پايين قرمز",
  "block.minecraft.banner.triangle_bottom.white": "مثلث پايين سفيد",
  "block.minecraft.banner.triangle_bottom.yellow": "مثلث پايين زرد",
  "block.minecraft.banner.triangle_top.black": "مثلث بالا سياه",
  "block.minecraft.banner.triangle_top.blue": "مثلث بالا آبی",
  "block.minecraft.banner.triangle_top.brown": "مثلث بالا قهوه‌ای",
  "block.minecraft.banner.triangle_top.cyan": "مثلث بالا فيروزه ای",
  "block.minecraft.banner.triangle_top.gray": "مثلث بالا خاکستری",
  "block.minecraft.banner.triangle_top.green": "مثلث بالا سبز",
  "block.minecraft.banner.triangle_top.light_blue": "مثلث بالا آبی روشن",
  "block.minecraft.banner.triangle_top.light_gray": "مثلث بالا خاکستری روشن",
  "block.minecraft.banner.triangle_top.lime": "مثلث بالا سبز روشن",
  "block.minecraft.banner.triangle_top.magenta": "مثلث بالا ارغوانی",
  "block.minecraft.banner.triangle_top.orange": "مثلث بالا نارنجی",
  "block.minecraft.banner.triangle_top.pink": "مثلث بالا صورتی",
  "block.minecraft.banner.triangle_top.purple": "مثلث بالا بنفش",
  "block.minecraft.banner.triangle_top.red": "مثلث بالا قرمز",
  "block.minecraft.banner.triangle_top.white": "مثلث بالا سفيد",
  "block.minecraft.banner.triangle_top.yellow": "مثلث بالا زرد",
  "block.minecraft.banner.triangles_bottom.black": "موج پايين سياه",
  "block.minecraft.banner.triangles_bottom.blue": "موج پايين آبی",
  "block.minecraft.banner.triangles_bottom.brown": "موج پايين قهوه‌ای",
  "block.minecraft.banner.triangles_bottom.cyan": "موج پايين فيروزه ای",
  "block.minecraft.banner.triangles_bottom.gray": "موج پايين خاکستری",
  "block.minecraft.banner.triangles_bottom.green": "موج پايين سبز",
  "block.minecraft.banner.triangles_bottom.light_blue": "موج پايين آبی روشن",
  "block.minecraft.banner.triangles_bottom.light_gray": "موج پايين خاکستری روشن",
  "block.minecraft.banner.triangles_bottom.lime": "موج پايين سبز روشن",
  "block.minecraft.banner.triangles_bottom.magenta": "موج پايين ارغوانی",
  "block.minecraft.banner.triangles_bottom.orange": "موج پايين نارنجی",
  "block.minecraft.banner.triangles_bottom.pink": "موج پايين صورتی",
  "block.minecraft.banner.triangles_bottom.purple": "موج پايين بنفش",
  "block.minecraft.banner.triangles_bottom.red": "موج پايين قرمز",
  "block.minecraft.banner.triangles_bottom.white": "موج پايين سفيد",
  "block.minecraft.banner.triangles_bottom.yellow": "موج پايين زرد",
  "block.minecraft.banner.triangles_top.black": "موج بالا سياه",
  "block.minecraft.banner.triangles_top.blue": "موج بالا آبی",
  "block.minecraft.banner.triangles_top.brown": "موج بالا قهوه‌ای",
  "block.minecraft.banner.triangles_top.cyan": "موج بالا فيروزه ای",
  "block.minecraft.banner.triangles_top.gray": "موج بالا خاکستری",
  "block.minecraft.banner.triangles_top.green": "موج بالا سبز",
  "block.minecraft.banner.triangles_top.light_blue": "موج بالا آبی روشن",
  "block.minecraft.banner.triangles_top.light_gray": "موج بالا خاکستری روشن",
  "block.minecraft.banner.triangles_top.lime": "موج بالا سبز روشن",
  "block.minecraft.banner.triangles_top.magenta": "موج بالا ارغوانی",
  "block.minecraft.banner.triangles_top.orange": "موج بالا نارنجی",
  "block.minecraft.banner.triangles_top.pink": "موج بالا صورتی",
  "block.minecraft.banner.triangles_top.purple": "موج بالا بنفش",
  "block.minecraft.banner.triangles_top.red": "موج بالا قرمز",
  "block.minecraft.banner.triangles_top.white": "موج بالا سفيد",
  "block.minecraft.banner.triangles_top.yellow": "موج بالا زرد",
  "block.minecraft.barrel": "بشکه",
  "block.minecraft.barrier": "مانع",
  "block.minecraft.basalt": "بازالت",
  "block.minecraft.beacon": "فانوس",
  "block.minecraft.beacon.primary": "قدرت اولیه",
  "block.minecraft.beacon.secondary": "قدرت ثانويه",
  "block.minecraft.bed.no_sleep": "شما فقط می توانید شب ها یا هنگام طوفان بخوابید",
  "block.minecraft.bed.not_safe": "شما اکنون نمی توانید استراحت کنید چون در این نزدیکی هیولا وجود دارد",
  "block.minecraft.bed.obstructed": "این تخت اشغال شده است",
  "block.minecraft.bed.occupied": "اين تختخواب گرفته شده است",
  "block.minecraft.bed.too_far_away": "شما اکنون نمی توانید استراحت نکنید؛ زیرا تخت با شما فاصله دارد",
  "block.minecraft.bedrock": "سنگ بستر",
  "block.minecraft.bee_nest": "کندو",
  "block.minecraft.beehive": "لانه زنبور",
  "block.minecraft.beetroots": "چغندر ها",
  "block.minecraft.bell": "ناقوس",
  "block.minecraft.big_dripleaf": "چکه‌برگ بزرگ",
  "block.minecraft.big_dripleaf_stem": "ساقه چکه‌برگ بزرگ",
  "block.minecraft.birch_button": "دکمه توسی",
  "block.minecraft.birch_door": "درب توس",
  "block.minecraft.birch_fence": "نرده توس",
  "block.minecraft.birch_fence_gate": "درب نرده توس",
  "block.minecraft.birch_hanging_sign": "تابلو آويزان چوب توس",
  "block.minecraft.birch_leaves": "برگ توس",
  "block.minecraft.birch_log": "تنه درخت توس",
  "block.minecraft.birch_planks": "الوار توس",
  "block.minecraft.birch_pressure_plate": "صفحه فشاری توس",
  "block.minecraft.birch_sapling": "نهال درخت توس",
  "block.minecraft.birch_shelf": "قفسه کتاب توس",
  "block.minecraft.birch_sign": "تابلو چوب توس",
  "block.minecraft.birch_slab": "تخته توس",
  "block.minecraft.birch_stairs": "پله توس",
  "block.minecraft.birch_trapdoor": "دريچه‌ی توسی",
  "block.minecraft.birch_wall_hanging_sign": "تابلو آويزان ديوار چوب توس",
  "block.minecraft.birch_wall_sign": "تابلو ديواری چوب توس",
  "block.minecraft.birch_wood": "چوب توس",
  "block.minecraft.black_banner": "پرچم سياه",
  "block.minecraft.black_bed": "تخت سياه",
  "block.minecraft.black_candle": "شمع سياه",
  "block.minecraft.black_candle_cake": "کيک با شمع سياه",
  "block.minecraft.black_carpet": "فرش سياه",
  "block.minecraft.black_concrete": "بتن سياه",
  "block.minecraft.black_concrete_powder": "پودر بتن سياه",
  "block.minecraft.black_glazed_terracotta": "سفال لعاب داده شده سياه",
  "block.minecraft.black_shulker_box": "جعبه سياه شالکر",
  "block.minecraft.black_stained_glass": "شيشه سياه رنگ",
  "block.minecraft.black_stained_glass_pane": "شيشه پنجره سياه رنگ",
  "block.minecraft.black_terracotta": "سفال سياه",
  "block.minecraft.black_wool": "پشم مشکي",
  "block.minecraft.blackstone": "سياه‌سنگ",
  "block.minecraft.blackstone_slab": "نیمه بلوک سياه‌سنگ",
  "block.minecraft.blackstone_stairs": "پله سياه‌سنگ",
  "block.minecraft.blackstone_wall": "ديوار سياه‌سنگ",
  "block.minecraft.blast_furnace": "کوره ذوب",
  "block.minecraft.blue_banner": "پرچم آبی",
  "block.minecraft.blue_bed": "تخت آبی",
  "block.minecraft.blue_candle": "شمع آبی",
  "block.minecraft.blue_candle_cake": "کيک با شمع آبی",
  "block.minecraft.blue_carpet": "فرش آبی",
  "block.minecraft.blue_concrete": "بتن آبی",
  "block.minecraft.blue_concrete_powder": "پودر بتن آبی",
  "block.minecraft.blue_glazed_terracotta": "سفال لعاب داده شده آبی",
  "block.minecraft.blue_ice": "يخ آبی",
  "block.minecraft.blue_orchid": "گل ارکيده آبی",
  "block.minecraft.blue_shulker_box": "جعبه آبی شالکر",
  "block.minecraft.blue_stained_glass": "شيشه آبی رنگ",
  "block.minecraft.blue_stained_glass_pane": "شيشه پنجره آبی رنگ",
  "block.minecraft.blue_terracotta": "سفال آبی",
  "block.minecraft.blue_wool": "پشم آبي",
  "block.minecraft.bone_block": "بلوک استخوان",
  "block.minecraft.bookshelf": "قفسه کتاب",
  "block.minecraft.brain_coral": "مرجان مغزی",
  "block.minecraft.brain_coral_block": "بلوک مرجان مغزی",
  "block.minecraft.brain_coral_fan": "مغز بادبزن مرجانی",
  "block.minecraft.brain_coral_wall_fan": "ديوار مغزی بادبزن مرجانی",
  "block.minecraft.brewing_stand": "معجون ساز",
  "block.minecraft.brick_slab": "نيمه بلوک آجر",
  "block.minecraft.brick_stairs": "پله آجري",
  "block.minecraft.brick_wall": "ديوار آجری",
  "block.minecraft.bricks": "بلوک آجر",
  "block.minecraft.brown_banner": "پرچم قهوه‌ای",
  "block.minecraft.brown_bed": "تخت قهوه‌ای",
  "block.minecraft.brown_candle": "شمع قهوه‌ای",
  "block.minecraft.brown_candle_cake": "کيک با شمع قهوه‌ای",
  "block.minecraft.brown_carpet": "فرش قهوه‌ای",
  "block.minecraft.brown_concrete": "بتن قهوه‌ای",
  "block.minecraft.brown_concrete_powder": "پودر بتن قهوه‌ای",
  "block.minecraft.brown_glazed_terracotta": "سفال لعاب شده قهوه‌ای",
  "block.minecraft.brown_mushroom": "قارچ قهوه‌ای",
  "block.minecraft.brown_mushroom_block": "بلوک قارچ قهوه‌ای",
  "block.minecraft.brown_shulker_box": "جعبه قهوه‌ای شالکر",
  "block.minecraft.brown_stained_glass": "شيشه رنگ قهوه‌ای",
  "block.minecraft.brown_stained_glass_pane": "شيشه پنجره قهوه‌ای رنگ",
  "block.minecraft.brown_terracotta": "سفال قهوه‌ای",
  "block.minecraft.brown_wool": "پشم قهوه اي",
  "block.minecraft.bubble_column": "ستون حباب",
  "block.minecraft.bubble_coral": "مرجان حبابی",
  "block.minecraft.bubble_coral_block": "بلوک مرجان حبابی",
  "block.minecraft.bubble_coral_fan": "حباب بادبزن مرجانی",
  "block.minecraft.bubble_coral_wall_fan": "ديوار حباب لوله ای بادبزن مرجانی",
  "block.minecraft.budding_amethyst": "جوانه‌زن ياقوت ارغوانی",
  "block.minecraft.bush": "بوته",
  "block.minecraft.cactus": "کاکتوس",
  "block.minecraft.cactus_flower": "گل کاکتوس",
  "block.minecraft.cake": "کيک",
  "block.minecraft.calcite": "کلسیت",
  "block.minecraft.calibrated_sculk_sensor": "حسگر اسکالک کاليبره شده",
  "block.minecraft.campfire": "کنده آتش",
  "block.minecraft.candle": "شمع",
  "block.minecraft.candle_cake": "کيک با شمع",
  "block.minecraft.carrots": "هويج",
  "block.minecraft.cartography_table": "ميز نقشه برداری",
  "block.minecraft.carved_pumpkin": "کدو تنبل تراشیده شده",
  "block.minecraft.cauldron": "ديگ",
  "block.minecraft.cave_air": "هوای غار",
  "block.minecraft.cave_vines": "انگور های غار",
  "block.minecraft.cave_vines_plant": "گیاه انگور های غار",
  "block.minecraft.chain": "زنجیر",
  "block.minecraft.chain_command_block": "بلاک فرمان زنجیره ای",
  "block.minecraft.cherry_button": "دکمه چوب گيلاس",
  "block.minecraft.cherry_door": "درب چوب گيلاس",
  "block.minecraft.cherry_fence": "نرده چوب گيلاس",
  "block.minecraft.cherry_fence_gate": "درب نرده چوب گيلاس",
  "block.minecraft.cherry_hanging_sign": "تابلو آويزان چوب گيلاس",
  "block.minecraft.cherry_leaves": "برگ درخت گيلاس",
  "block.minecraft.cherry_log": "تنه درخت گيلاس",
  "block.minecraft.cherry_planks": "الوار درخت گيلاس",
  "block.minecraft.cherry_pressure_plate": "صفحه فشاری چوب گيلاس",
  "block.minecraft.cherry_sapling": "نهال درخت گيلاس",
  "block.minecraft.cherry_shelf": "قفسه کتاب چوب گيلاس",
  "block.minecraft.cherry_sign": "تابلو چوب گيلاس",
  "block.minecraft.cherry_slab": "تخته چوب گيلاس",
  "block.minecraft.cherry_stairs": "پله چوب گيلاس",
  "block.minecraft.cherry_trapdoor": "دريچه‌ی چوب گيلاس",
  "block.minecraft.cherry_wall_hanging_sign": "تابلو آويزان ديوار چوب گيلاس",
  "block.minecraft.cherry_wall_sign": "تابلو ديواری چوب گيلاس",
  "block.minecraft.cherry_wood": "چوب درخت گيلاس",
  "block.minecraft.chest": "صندوقچه",
  "block.minecraft.chipped_anvil": "سندان ترک برداشته",
  "block.minecraft.chiseled_bookshelf": "قفسه کتاب تراش خورده",
  "block.minecraft.chiseled_copper": "مس تراش خورده",
  "block.minecraft.chiseled_deepslate": "سنگ عميق تراش خورده",
  "block.minecraft.chiseled_nether_bricks": "آجر ندری تراش‌خورده",
  "block.minecraft.chiseled_polished_blackstone": "آجر سياه‌سنگ صيقلی تراش‌خورده",
  "block.minecraft.chiseled_quartz_block": "بلوک کوارتز تراشي",
  "block.minecraft.chiseled_red_sandstone": "ماسه سنگ قرمز تراش خورده",
  "block.minecraft.chiseled_resin_bricks": "آجر صمغ تراش خورده",
  "block.minecraft.chiseled_sandstone": "ماسه سنگ تراش خورده",
  "block.minecraft.chiseled_stone_bricks": "آجرسنگ تراش خورده",
  "block.minecraft.chiseled_tuff": "سنگ خاکستر تراش خورده",
  "block.minecraft.chiseled_tuff_bricks": "آجرسنگ خاکستر تراش خورده",
  "block.minecraft.chorus_flower": "گل کر",
  "block.minecraft.chorus_plant": "گیاه کر",
  "block.minecraft.clay": "خاک رس",
  "block.minecraft.closed_eyeblossom": "شکوفه‌چشم بسته",
  "block.minecraft.coal_block": "بلوک زغال سنگ",
  "block.minecraft.coal_ore": "سنگ معدن زغال",
  "block.minecraft.coarse_dirt": "خاک شور",
  "block.minecraft.cobbled_deepslate": "قلوه سنگ عميق",
  "block.minecraft.cobbled_deepslate_slab": "نيمه قلوه سنگ عميق",
  "block.minecraft.cobbled_deepslate_stairs": "پله قلوه سنگ عميق",
  "block.minecraft.cobbled_deepslate_wall": "ديوار قلوه سنگ عميق",
  "block.minecraft.cobblestone": "قلوه سنگ",
  "block.minecraft.cobblestone_slab": "نيمه قلوه سنگ",
  "block.minecraft.cobblestone_stairs": "پله قلوه سنگی",
  "block.minecraft.cobblestone_wall": "ديوار قلوه سنگی",
  "block.minecraft.cobweb": "تار عنکبوت",
  "block.minecraft.cocoa": "کاکائو",
  "block.minecraft.command_block": "بلوک دستور",
  "block.minecraft.comparator": "مقايسه‌گر ردستوني",
  "block.minecraft.composter": "کودساز",
  "block.minecraft.conduit": "جریان انداز",
  "block.minecraft.copper_bars": "ميله مسی",
  "block.minecraft.copper_block": "بلوک مس",
  "block.minecraft.copper_bulb": "لامپ مس",
  "block.minecraft.copper_chain": "زنجیر مسی",
  "block.minecraft.copper_chest": "صندوقچه مس",
  "block.minecraft.copper_door": "درب مس",
  "block.minecraft.copper_golem_statue": "مجسمه غول مسی",
  "block.minecraft.copper_grate": "قفس مس",
  "block.minecraft.copper_lantern": "فانوس مسی",
  "block.minecraft.copper_ore": "سنگ معدن مس",
  "block.minecraft.copper_torch": "مشعل مسی",
  "block.minecraft.copper_trapdoor": "دريچه مس",
  "block.minecraft.copper_wall_torch": "مشعل دیواری مسی",
  "block.minecraft.cornflower": "گل‌گندم",
  "block.minecraft.cracked_deepslate_bricks": "آجرسنگ عميق ترک‌خورده",
  "block.minecraft.cracked_deepslate_tiles": "کاشی های ترک‌خورده سنگ عميق",
  "block.minecraft.cracked_nether_bricks": "آجر ندری ترک‌خورده",
  "block.minecraft.cracked_polished_blackstone_bricks": "آجر سياه‌سنگ صيقلی ترک‌خورده",
  "block.minecraft.cracked_stone_bricks": "آجرسنگ ترک خورده",
  "block.minecraft.crafter": "سازنده",
  "block.minecraft.crafting_table": "ميزکار",
  "block.minecraft.creaking_heart": "قلب کريکينگ",
  "block.minecraft.creeper_head": "سر کریپر",
  "block.minecraft.creeper_wall_head": "سر ديواری کریپر",
  "block.minecraft.crimson_button": "دکمه کريمسون",
  "block.minecraft.crimson_door": "درب کريمسون",
  "block.minecraft.crimson_fence": "نرده کريمسون",
  "block.minecraft.crimson_fence_gate": "درب نرده کريمسون",
  "block.minecraft.crimson_fungus": "قارچ کريمسون",
  "block.minecraft.crimson_hanging_sign": "تابلو آويزان چوب کريمسون",
  "block.minecraft.crimson_hyphae": "سرشاخه کريمسون",
  "block.minecraft.crimson_nylium": "نيليوم کريمسون",
  "block.minecraft.crimson_planks": "الوار کريمسون",
  "block.minecraft.crimson_pressure_plate": "صفحه فشاری کريمسون",
  "block.minecraft.crimson_roots": "ریشه های کريمسون",
  "block.minecraft.crimson_shelf": "قفسه کتاب کريمسون",
  "block.minecraft.crimson_sign": "تابلوی چوب کريمسون",
  "block.minecraft.crimson_slab": "نيمه بلوک کريمسون",
  "block.minecraft.crimson_stairs": "پله چوب کريمسون",
  "block.minecraft.crimson_stem": "ساقه کريمسون",
  "block.minecraft.crimson_trapdoor": "دريچه‌ی کريمسون",
  "block.minecraft.crimson_wall_hanging_sign": "تابلو آويزان ديوار چوب کريمسون",
  "block.minecraft.crimson_wall_sign": "تابلوی ديواری کريمسون",
  "block.minecraft.crying_obsidian": "آبسيديان گريان",
  "block.minecraft.cut_copper": "مس برش خورده",
  "block.minecraft.cut_copper_slab": "نيمه مس برش خورده",
  "block.minecraft.cut_copper_stairs": "پله مس برش خورده",
  "block.minecraft.cut_red_sandstone": "ماسه سنگ قرمز برش خورده",
  "block.minecraft.cut_red_sandstone_slab": "نيمه ماسه سنگ قرمز برش خورده",
  "block.minecraft.cut_sandstone": "ماسه سنگ برش خورده",
  "block.minecraft.cut_sandstone_slab": "نيمه ماسه سنگ برش خورده",
  "block.minecraft.cyan_banner": "پرچم آبی روشن",
  "block.minecraft.cyan_bed": "تخت فيروزه‌ای",
  "block.minecraft.cyan_candle": "شمع فيروزه‌ای",
  "block.minecraft.cyan_candle_cake": "کيک با شمع فيروزه‌ای",
  "block.minecraft.cyan_carpet": "فرش فيروزه‌ای",
  "block.minecraft.cyan_concrete": "بتن فيروزه‌ای",
  "block.minecraft.cyan_concrete_powder": "پودر بتن فيروزه‌ای",
  "block.minecraft.cyan_glazed_terracotta": "سفال لعاب داده شده فيروزه‌ای",
  "block.minecraft.cyan_shulker_box": "جعبه فيروزه‌ای شالکر",
  "block.minecraft.cyan_stained_glass": "شيشه فيروزه‌ای رنگ",
  "block.minecraft.cyan_stained_glass_pane": "شيشه پنجره فيروزه‌ای رنگ",
  "block.minecraft.cyan_terracotta": "سفال فيروزه‌ای",
  "block.minecraft.cyan_wool": "پشم فيروزه اي",
  "block.minecraft.damaged_anvil": "سندان آسيب ديده",
  "block.minecraft.dandelion": "گل قاصدک",
  "block.minecraft.dark_oak_button": "دکمه بلوط تيره",
  "block.minecraft.dark_oak_door": "درب بلوط تيره",
  "block.minecraft.dark_oak_fence": "نرده بلوط تيره",
  "block.minecraft.dark_oak_fence_gate": "درب نرده بلوط تيره",
  "block.minecraft.dark_oak_hanging_sign": "تابلو آويزان چوب بلوط تيره",
  "block.minecraft.dark_oak_leaves": "برگ بلوط تيره",
  "block.minecraft.dark_oak_log": "تنه درخت بلوط تيره",
  "block.minecraft.dark_oak_planks": "الوار بلوط تيره",
  "block.minecraft.dark_oak_pressure_plate": "صفحه فشاری بلوط تيره",
  "block.minecraft.dark_oak_sapling": "نهال بلوط تيره",
  "block.minecraft.dark_oak_shelf": "قفسه کتاب بلوط تيره",
  "block.minecraft.dark_oak_sign": "تابلو چوب بلوط سياه",
  "block.minecraft.dark_oak_slab": "تخته بلوط تيره",
  "block.minecraft.dark_oak_stairs": "پله بلوط تيره",
  "block.minecraft.dark_oak_trapdoor": "دريچه‌ی بلوط تيره",
  "block.minecraft.dark_oak_wall_hanging_sign": "تابلو آويزان ديوار چوب بلوط تيره",
  "block.minecraft.dark_oak_wall_sign": "تابلو ديواری چوب بلوط تيره",
  "block.minecraft.dark_oak_wood": "چوب بلوط تيره",
  "block.minecraft.dark_prismarine": "منشور دريايی تيره",
  "block.minecraft.dark_prismarine_slab": "تخته منشور دريايی تيره",
  "block.minecraft.dark_prismarine_stairs": "پله منشور دريايی تيره",
  "block.minecraft.daylight_detector": "سنسور نور",
  "block.minecraft.dead_brain_coral": "مرجان مغزی مرده",
  "block.minecraft.dead_brain_coral_block": "بلوک مرجان مغزی مرده",
  "block.minecraft.dead_brain_coral_fan": "مرجان مغزی مرده",
  "block.minecraft.dead_brain_coral_wall_fan": "ديوار مغزی بادبزن مرجانی مرده",
  "block.minecraft.dead_bubble_coral": "حباب مرجانی مرده",
  "block.minecraft.dead_bubble_coral_block": "بلوک مرجان حبابی مرده",
  "block.minecraft.dead_bubble_coral_fan": "مرجان حبابی مرده",
  "block.minecraft.dead_bubble_coral_wall_fan": "ديوار حباب لوله ای بادبزن مرجانی مرده",
  "block.minecraft.dead_bush": "بته خشک",
  "block.minecraft.dead_fire_coral": "مرجان آتشین مرده",
  "block.minecraft.dead_fire_coral_block": "بلوک مرجان آتشین مرده",
  "block.minecraft.dead_fire_coral_fan": "مرجان آتشین مرده",
  "block.minecraft.dead_fire_coral_wall_fan": "ديوار مرجان آتشین مرده",
  "block.minecraft.dead_horn_coral": "مرجان شاخی مرده",
  "block.minecraft.dead_horn_coral_block": "بلوک مرجان شاخکی مرده",
  "block.minecraft.dead_horn_coral_fan": "مرجان شاخکی مرده",
  "block.minecraft.dead_horn_coral_wall_fan": "ديوار مرجان شاخکی مرده",
  "block.minecraft.dead_tube_coral": "مرجان لوله‌ای مرده",
  "block.minecraft.dead_tube_coral_block": "بلوک مرجان لوله‌ای مرده",
  "block.minecraft.dead_tube_coral_fan": "مرجان لوله ای مرده",
  "block.minecraft.dead_tube_coral_wall_fan": "ديوار لوله ای بادبزن مرجانی مرده",
  "block.minecraft.decorated_pot": "کوزه تزئينی",
  "block.minecraft.deepslate": "سنگ عميق",
  "block.minecraft.deepslate_brick_slab": "نيمه آجرسنگ عميق",
  "block.minecraft.deepslate_brick_stairs": "پله آجرسنگ عميق",
  "block.minecraft.deepslate_brick_wall": "ديوار آجرسنگ عميق",
  "block.minecraft.deepslate_bricks": "آجرسنگ عميق",
  "block.minecraft.deepslate_coal_ore": "سنگ معدن عميق زغال",
  "block.minecraft.deepslate_copper_ore": "سنگ معدن عميق مس",
  "block.minecraft.deepslate_diamond_ore": "سنگ معدن عميق الماس",
  "block.minecraft.deepslate_emerald_ore": "سنگ معدن عميق زمرد",
  "block.minecraft.deepslate_gold_ore": "سنگ معدن عميق طلا",
  "block.minecraft.deepslate_iron_ore": "سنگ معدن عميق آهن",
  "block.minecraft.deepslate_lapis_ore": "سنگ معدن عميق لاجورد",
  "block.minecraft.deepslate_redstone_ore": "سنگ معدن عميق ردستون",
  "block.minecraft.deepslate_tile_slab": "نيمه کاشی سنگ عميق",
  "block.minecraft.deepslate_tile_stairs": "پله کاشی سنگ عميق",
  "block.minecraft.deepslate_tile_wall": "ديوار کاشی سنگ عميق",
  "block.minecraft.deepslate_tiles": "کاشی سنگ عميق",
  "block.minecraft.detector_rail": "ريل تشخيص‌دهنده",
  "block.minecraft.diamond_block": "بلوک الماس",
  "block.minecraft.diamond_ore": "سنگ معدن الماس",
  "block.minecraft.diorite": "ديوريت",
  "block.minecraft.diorite_slab": "نيمه ديوريت",
  "block.minecraft.diorite_stairs": "پله ديوريت",
  "block.minecraft.diorite_wall": "ديوار ديوريت",
  "block.minecraft.dirt": "خاک",
  "block.minecraft.dirt_path": "مسیر خاکی",
  "block.minecraft.dispenser": "توزيعگر",
  "block.minecraft.dragon_egg": "تخم اژدها",
  "block.minecraft.dragon_head": "سر اژدها",
  "block.minecraft.dragon_wall_head": "سر ديواری اژدها",
  "block.minecraft.dried_ghast": "گست خشک‌شده",
  "block.minecraft.dried_kelp_block": "بلوک جلبک دريايی خشک شده",
  "block.minecraft.dripstone_block": "بلوک چکنده‌سنگ",
  "block.minecraft.dropper": "پرتابگر",
  "block.minecraft.emerald_block": "بلوک زمرد",
  "block.minecraft.emerald_ore": "سنگ معدن زمرد",
  "block.minecraft.enchanting_table": "ميز افسونگری",
  "block.minecraft.end_gateway": "دروازه دنيای اِند",
  "block.minecraft.end_portal": "درگاه فرجام",
  "block.minecraft.end_portal_frame": "چارچوب درگاه فرجام",
  "block.minecraft.end_rod": "ميله فرجام",
  "block.minecraft.end_stone": "سنگ فرجام",
  "block.minecraft.end_stone_brick_slab": "نیمه بلوک آجر سنگ",
  "block.minecraft.end_stone_brick_stairs": "پله آجر سنگ اند",
  "block.minecraft.end_stone_brick_wall": "ديوار آجر سنگ اند",
  "block.minecraft.end_stone_bricks": "آجر سنگ اند",
  "block.minecraft.ender_chest": "صندوقچه آخرت",
  "block.minecraft.exposed_chiseled_copper": "مس تراش خورده هوا ديده",
  "block.minecraft.exposed_copper": "مس هوا ديده",
  "block.minecraft.exposed_copper_bars": "ميله مسی هوا ديده",
  "block.minecraft.exposed_copper_bulb": "لامپ مس هوا ديده",
  "block.minecraft.exposed_copper_chain": "زنجیر مسی هوا ديده",
  "block.minecraft.exposed_copper_chest": "صندوقچه مس هوا ديده",
  "block.minecraft.exposed_copper_door": "درب مس هوا ديده",
  "block.minecraft.exposed_copper_golem_statue": "مجسمه غول مسی هوا دیده",
  "block.minecraft.exposed_copper_grate": "قفس مس هوا ديده",
  "block.minecraft.exposed_copper_lantern": "فانوس مسی هوا ديده",
  "block.minecraft.exposed_copper_trapdoor": "دريچه مس هوا ديده",
  "block.minecraft.exposed_cut_copper": "مس برش خورده هوا ديده",
  "block.minecraft.exposed_cut_copper_slab": "نيمه مس برش خورده هوا ديده",
  "block.minecraft.exposed_cut_copper_stairs": "پله مس برش خورده هوا ديده",
  "block.minecraft.exposed_lightning_rod": "ميله برق گير هوا ديده",
  "block.minecraft.farmland": "خاک مزرعه",
  "block.minecraft.fern": "بوته سرخس",
  "block.minecraft.fire": "آتش",
  "block.minecraft.fire_coral": "مرجان آتشین",
  "block.minecraft.fire_coral_block": "بلوک مرجان آتشین",
  "block.minecraft.fire_coral_fan": "مرجان آتشین",
  "block.minecraft.fire_coral_wall_fan": "ديوار باد بزن آتش مرجانی",
  "block.minecraft.firefly_bush": "بوته کرم شب‌تاب",
  "block.minecraft.fletching_table": "ميز تيرِكمان سازی",
  "block.minecraft.flower_pot": "گلدان",
  "block.minecraft.flowering_azalea": "آزالیا گل‌دهنده",
  "block.minecraft.flowering_azalea_leaves": "برگ های گل‌دهنده آزالیا",
  "block.minecraft.frogspawn": "تخم قورباغه",
  "block.minecraft.frosted_ice": "يخ مات",
  "block.minecraft.furnace": "اجاق",
  "block.minecraft.gilded_blackstone": "سياه‌سنگ تذهيب شده",
  "block.minecraft.glass": "شيشه",
  "block.minecraft.glass_pane": "شيشه پنجره",
  "block.minecraft.glow_lichen": "گلسنگ نورانی",
  "block.minecraft.glowstone": "سنگ روشنا",
  "block.minecraft.gold_block": "بلوک طلا",
  "block.minecraft.gold_ore": "سنگ معدن طلا",
  "block.minecraft.golden_dandelion": "قاصدک طلايی",
  "block.minecraft.granite": "گرانيت",
  "block.minecraft.granite_slab": "نيمه گرانيت",
  "block.minecraft.granite_stairs": "پله گرانيت",
  "block.minecraft.granite_wall": "ديوار گرانيت",
  "block.minecraft.grass": "چمن",
  "block.minecraft.grass_block": "بلوک چمن",
  "block.minecraft.gravel": "ريگ",
  "block.minecraft.gray_banner": "پرچم خاکستری",
  "block.minecraft.gray_bed": "تخت خاکستری",
  "block.minecraft.gray_candle": "شمع خاکستری",
  "block.minecraft.gray_candle_cake": "کيک با شمع خاکستری",
  "block.minecraft.gray_carpet": "فرش خاکستری",
  "block.minecraft.gray_concrete": "بتن خاکستری",
  "block.minecraft.gray_concrete_powder": "پودر بتن خاکستری",
  "block.minecraft.gray_glazed_terracotta": "سفال لعاب داده شده خاکستری",
  "block.minecraft.gray_shulker_box": "جعبه خاکستری شالکر",
  "block.minecraft.gray_stained_glass": "شيشه خاکستری رنگ",
  "block.minecraft.gray_stained_glass_pane": "شيشه پنجره خاکستری رنگ",
  "block.minecraft.gray_terracotta": "سفال خاکستری",
  "block.minecraft.gray_wool": "پشم خاکستري",
  "block.minecraft.green_banner": "پرچم سبز",
  "block.minecraft.green_bed": "تخت سبز",
  "block.minecraft.green_candle": "شمع سبز",
  "block.minecraft.green_candle_cake": "کيک با شمع سبز",
  "block.minecraft.green_carpet": "فرش سبز",
  "block.minecraft.green_concrete": "بتن سبز",
  "block.minecraft.green_concrete_powder": "پودر بتن سبز",
  "block.minecraft.green_glazed_terracotta": "سفال لعاب داده شده سبز",
  "block.minecraft.green_shulker_box": "جعبه سبز شالکر",
  "block.minecraft.green_stained_glass": "شيشه سبز رنگ",
  "block.minecraft.green_stained_glass_pane": "شيشه پنجره سبز رنگ",
  "block.minecraft.green_terracotta": "سفال سبز",
  "block.minecraft.green_wool": "پشم سبز",
  "block.minecraft.grindstone": "سنگ سمباده",
  "block.minecraft.hanging_roots": "ریشه های آویزان",
  "block.minecraft.hay_block": "بلوک گندم",
  "block.minecraft.heavy_core": "هسته سنگين",
  "block.minecraft.heavy_weighted_pressure_plate": "صفحه فشاری سنگین وزن",
  "block.minecraft.honey_block": "بلوک عسل",
  "block.minecraft.honeycomb_block": "بلوک موم عسل",
  "block.minecraft.hopper": "قيف",
  "block.minecraft.horn_coral": "مرجان شاخکی",
  "block.minecraft.horn_coral_block": "بلوک مرجان شاخکی",
  "block.minecraft.horn_coral_fan": "مرجان شاخدار",
  "block.minecraft.horn_coral_wall_fan": "ديوار مغزی باد بزن مرجانی",
  "block.minecraft.ice": "يخ",
  "block.minecraft.infested_chiseled_stone_bricks": "آجر سنگ تراش خورده آفت زده",
  "block.minecraft.infested_cobblestone": "قلوه سنگ آفت زده",
  "block.minecraft.infested_cracked_stone_bricks": "آجرسنگ ترک برداشته آفت زده",
  "block.minecraft.infested_deepslate": "سنگ عميق آفت‌زده",
  "block.minecraft.infested_mossy_stone_bricks": "آجرسنگ لجنی آفت زده",
  "block.minecraft.infested_stone": "سنگ آفت زده",
  "block.minecraft.infested_stone_bricks": "آجرسنگ آفت زده",
  "block.minecraft.iron_bars": "ميله هایآهني",
  "block.minecraft.iron_block": "بلوک آهن",
  "block.minecraft.iron_chain": "زنجير آهنی",
  "block.minecraft.iron_door": "درب آهنی",
  "block.minecraft.iron_ore": "سنگ معدن آهن",
  "block.minecraft.iron_trapdoor": "دريچه آهنی",
  "block.minecraft.jack_o_lantern": "کدوتنبل نورانی",
  "block.minecraft.jigsaw": "بلاک منبت کاری",
  "block.minecraft.jukebox": "جعبه موسيقي",
  "block.minecraft.jungle_button": "دکمه جنگلی",
  "block.minecraft.jungle_door": "درب جنگلی",
  "block.minecraft.jungle_fence": "نرده جنگلی",
  "block.minecraft.jungle_fence_gate": "درب نرده جنگلی",
  "block.minecraft.jungle_hanging_sign": "تابلو آويزان چوب جنگلی",
  "block.minecraft.jungle_leaves": "برگ جنگلی",
  "block.minecraft.jungle_log": "کنده ی چوب جنگلی",
  "block.minecraft.jungle_planks": "الوار جنگلی",
  "block.minecraft.jungle_pressure_plate": "صفحه فشاری جنگلی",
  "block.minecraft.jungle_sapling": "نحال درخت جنگلی",
  "block.minecraft.jungle_shelf": "قفسه کتاب جنگلی",
  "block.minecraft.jungle_sign": "تابلو چوب جنگلی",
  "block.minecraft.jungle_slab": "تخته جنگلی",
  "block.minecraft.jungle_stairs": "پله چوب جنگلی",
  "block.minecraft.jungle_trapdoor": "دريچه‌ی جنگلی",
  "block.minecraft.jungle_wall_hanging_sign": "تابلو آويزان ديوار چوب جنگلی",
  "block.minecraft.jungle_wall_sign": "تابلو ديواری چوب جنگل",
  "block.minecraft.jungle_wood": "چوب جنگلی",
  "block.minecraft.kelp": "جلبک دريايی",
  "block.minecraft.kelp_plant": "گیاه دريايی",
  "block.minecraft.ladder": "نردبان",
  "block.minecraft.lantern": "فانوس",
  "block.minecraft.lapis_block": "بلوک لاجورد",
  "block.minecraft.lapis_ore": "سنگ معدن لاجورد",
  "block.minecraft.large_amethyst_bud": "جوانه بزرگ ياقوت ارغوانی",
  "block.minecraft.large_fern": "سرخس بزرگ",
  "block.minecraft.lava": "گدازه",
  "block.minecraft.lava_cauldron": "دیگ گدازه",
  "block.minecraft.leaf_litter": "برگ خشک",
  "block.minecraft.lectern": "ميز قرائت",
  "block.minecraft.lever": "اهرم",
  "block.minecraft.light": "روشنايی",
  "block.minecraft.light_blue_banner": "پرچم آبی روشن",
  "block.minecraft.light_blue_bed": "تخت آبی روشن",
  "block.minecraft.light_blue_candle": "شمع آبی روشن",
  "block.minecraft.light_blue_candle_cake": "کيک با شمع آبی روشن",
  "block.minecraft.light_blue_carpet": "فرش آبی روشن",
  "block.minecraft.light_blue_concrete": "بتن آبی روشن",
  "block.minecraft.light_blue_concrete_powder": "پودر بتن آبی روشن",
  "block.minecraft.light_blue_glazed_terracotta": "سفال لعاب داده شده آبی روشن",
  "block.minecraft.light_blue_shulker_box": "جعبه آبی روشن شالکر",
  "block.minecraft.light_blue_stained_glass": "شيشه رنگ آبی روشن",
  "block.minecraft.light_blue_stained_glass_pane": "شيشه پنجره رنگ آبی روشن",
  "block.minecraft.light_blue_terracotta": "سفال آبی روشن",
  "block.minecraft.light_blue_wool": "پشم آبي آسماني",
  "block.minecraft.light_gray_banner": "پرچم نقره‌ای",
  "block.minecraft.light_gray_bed": "تخت خاکستری روشن",
  "block.minecraft.light_gray_candle": "شمع خاکستری روشن",
  "block.minecraft.light_gray_candle_cake": "کيک با شمع خاکستری روشن",
  "block.minecraft.light_gray_carpet": "فرش نقره‌ای",
  "block.minecraft.light_gray_concrete": "بتن خاکستری روشن",
  "block.minecraft.light_gray_concrete_powder": "پودر بتن خاکستری روشن",
  "block.minecraft.light_gray_glazed_terracotta": "سفال لعاب داده شده خاکستری روشن",
  "block.minecraft.light_gray_shulker_box": "جعبه نقره‌ای شالکر",
  "block.minecraft.light_gray_stained_glass": "شيشه نقره‌ای رنگ",
  "block.minecraft.light_gray_stained_glass_pane": "شيشه پنجره نقره‌ای رنگ",
  "block.minecraft.light_gray_terracotta": "سفال خاکستری روشن",
  "block.minecraft.light_gray_wool": "پشم نقره اي",
  "block.minecraft.light_weighted_pressure_plate": "صفحه فشاری سبک وزن",
  "block.minecraft.lightning_rod": "ميله برق گير",
  "block.minecraft.lilac": "گل ياس",
  "block.minecraft.lily_of_the_valley": "گل زنبق",
  "block.minecraft.lily_pad": "زنبق دريايي",
  "block.minecraft.lime_banner": "پرچم سبز روشن",
  "block.minecraft.lime_bed": "تخت سبز روشن",
  "block.minecraft.lime_candle": "شمع سبز روشن",
  "block.minecraft.lime_candle_cake": "کيک با شمع سبز روشن",
  "block.minecraft.lime_carpet": "فرش سبز روشن",
  "block.minecraft.lime_concrete": "بتن سبز روشن",
  "block.minecraft.lime_concrete_powder": "پودر بتن سبز روشن",
  "block.minecraft.lime_glazed_terracotta": "سفال لعاب داده شده سبز روشن",
  "block.minecraft.lime_shulker_box": "جعبه سبز روشن شالکر",
  "block.minecraft.lime_stained_glass": "شيشه رنگ سبز روشن",
  "block.minecraft.lime_stained_glass_pane": "شيشه پنجره رنگ سبز روشن",
  "block.minecraft.lime_terracotta": "سفال سبز روشن",
  "block.minecraft.lime_wool": "پشم فسفري",
  "block.minecraft.lodestone": "سنگ مرتعش",
  "block.minecraft.loom": "بلوک نساجی",
  "block.minecraft.magenta_banner": "پرچم ارغوانی",
  "block.minecraft.magenta_bed": "تخت ارغوانی",
  "block.minecraft.magenta_candle": "شمع ارغوانی",
  "block.minecraft.magenta_candle_cake": "کيک با شمع ارغوانی",
  "block.minecraft.magenta_carpet": "فرش ارغوانی",
  "block.minecraft.magenta_concrete": "بتن ارغوانی",
  "block.minecraft.magenta_concrete_powder": "پودر بتن ارغوانی",
  "block.minecraft.magenta_glazed_terracotta": "سفال لعاب داده شده ارغوانی",
  "block.minecraft.magenta_shulker_box": "جعبه ارغوانی شالکر",
  "block.minecraft.magenta_stained_glass": "شيشه ارغوانی",
  "block.minecraft.magenta_stained_glass_pane": "شيشه پنجره ارغوانی رنگ",
  "block.minecraft.magenta_terracotta": "سفال ارغوانی",
  "block.minecraft.magenta_wool": "پشم سرخآبي",
  "block.minecraft.magma_block": "بلاک ماگما",
  "block.minecraft.mangrove_button": "دکمه چوب حرا",
  "block.minecraft.mangrove_door": "درب درخت حرا",
  "block.minecraft.mangrove_fence": "نرده چوب حرا",
  "block.minecraft.mangrove_fence_gate": "درب نرده چوب حرا",
  "block.minecraft.mangrove_hanging_sign": "تابلو آويزان چوب حرا",
  "block.minecraft.mangrove_leaves": "برگ درخت حرا",
  "block.minecraft.mangrove_log": "تنه درخت حرا",
  "block.minecraft.mangrove_planks": "الوار درخت حرا",
  "block.minecraft.mangrove_pressure_plate": "صفحه فشاری چوب حرا",
  "block.minecraft.mangrove_propagule": "جوانه درخت حرا",
  "block.minecraft.mangrove_roots": "ريشه های درخت حرا",
  "block.minecraft.mangrove_shelf": "قفسه کتاب چوب حرا",
  "block.minecraft.mangrove_sign": "تابلو چوب حرا",
  "block.minecraft.mangrove_slab": "تخته الوار حرا",
  "block.minecraft.mangrove_stairs": "پله چوب حرا",
  "block.minecraft.mangrove_trapdoor": "دريچه‌ی چوب حرا",
  "block.minecraft.mangrove_wall_hanging_sign": "تابلو آويزان ديوار چوب حرا",
  "block.minecraft.mangrove_wall_sign": "تابلو ديواری چوب حرا",
  "block.minecraft.mangrove_wood": "چوب درخت حرا",
  "block.minecraft.medium_amethyst_bud": "جوانه متوسط ياقوت ارغوانی",
  "block.minecraft.melon": "هندوانه",
  "block.minecraft.melon_stem": "ساقه هندوانه",
  "block.minecraft.moss_block": "بلوک خزه",
  "block.minecraft.moss_carpet": "فرش خزه‌ای",
  "block.minecraft.mossy_cobblestone": "قلوه سنگ لجن زده",
  "block.minecraft.mossy_cobblestone_slab": "نيمه قلوه سنگ لجن زده",
  "block.minecraft.mossy_cobblestone_stairs": "پله قلوه سنگ لجن زده",
  "block.minecraft.mossy_cobblestone_wall": "ديوار قلوه سنگ لجن زده",
  "block.minecraft.mossy_stone_brick_slab": "نيمه آجرسنگ لجن زده",
  "block.minecraft.mossy_stone_brick_stairs": "پله آجرسنگ لجن زده",
  "block.minecraft.mossy_stone_brick_wall": "ديوار آجرسنگ لجن زده",
  "block.minecraft.mossy_stone_bricks": "آجرسنگ لجن زده",
  "block.minecraft.moving_piston": "پيستون متحرک",
  "block.minecraft.mud": "گِل",
  "block.minecraft.mud_brick_slab": "نيمه بلوک خشت و گِل",
  "block.minecraft.mud_brick_stairs": "پله خشت و گِلی",
  "block.minecraft.mud_brick_wall": "ديوار خشت و گِلی",
  "block.minecraft.mud_bricks": "خشت و گِل",
  "block.minecraft.muddy_mangrove_roots": "ريشه های گِلی درخت حرا",
  "block.minecraft.mushroom_stem": "ساقه قارچ",
  "block.minecraft.mycelium": "قارچخاک",
  "block.minecraft.nether_brick_fence": "حصار ندر",
  "block.minecraft.nether_brick_slab": "نيمه آجر ندر",
  "block.minecraft.nether_brick_stairs": "پله آجر ندر",
  "block.minecraft.nether_brick_wall": "ديوار آجر ندر",
  "block.minecraft.nether_bricks": "آجر ندر",
  "block.minecraft.nether_gold_ore": "سنگ معدن طلای ندر",
  "block.minecraft.nether_portal": "دروازه ندر",
  "block.minecraft.nether_quartz_ore": "سنگ معدن کوارتز ندر",
  "block.minecraft.nether_sprouts": "جوانه ندری",
  "block.minecraft.nether_wart": "زگيل ندر",
  "block.minecraft.nether_wart_block": "بلوک زگيل ندر",
  "block.minecraft.netherite_block": "بلوک ندرايت",
  "block.minecraft.netherrack": "سنگ ندر",
  "block.minecraft.note_block": "بلوک نت",
  "block.minecraft.oak_button": "دکمه بلوطی",
  "block.minecraft.oak_door": "درب بلوط",
  "block.minecraft.oak_fence": "نرده چوبی",
  "block.minecraft.oak_fence_gate": "دروازه چوبي",
  "block.minecraft.oak_hanging_sign": "تابلو آويزان چوب بلوط",
  "block.minecraft.oak_leaves": "برگ بلوط",
  "block.minecraft.oak_log": "تنه درخت بلوط",
  "block.minecraft.oak_planks": "الوار بلوط",
  "block.minecraft.oak_pressure_plate": "صفحه فشاری بلوط",
  "block.minecraft.oak_sapling": "نهال درخت بلوط",
  "block.minecraft.oak_shelf": "قفسه کتاب بلوط",
  "block.minecraft.oak_sign": "تابلو چوب بلوط",
  "block.minecraft.oak_slab": "تخته بلوط",
  "block.minecraft.oak_stairs": "پله بلوط",
  "block.minecraft.oak_trapdoor": "دريچه‌ی بلوطی",
  "block.minecraft.oak_wall_hanging_sign": "تابلو آويزان ديوار چوب بلوط",
  "block.minecraft.oak_wall_sign": "تابلو ديواری چوب بلوط",
  "block.minecraft.oak_wood": "چوب بلوط",
  "block.minecraft.observer": "نظاره‌گر",
  "block.minecraft.obsidian": "آبسيديان",
  "block.minecraft.ochre_froglight": "نورباغه زردگون",
  "block.minecraft.ominous_banner": "پرچم بديُمن",
  "block.minecraft.open_eyeblossom": "شکوفه‌چشم باز",
  "block.minecraft.orange_banner": "پرچم نارنجی",
  "block.minecraft.orange_bed": "تخت نارنجی",
  "block.minecraft.orange_candle": "شمع نارنجی",
  "block.minecraft.orange_candle_cake": "کيک با شمع نارنجی",
  "block.minecraft.orange_carpet": "فرش نارنجی",
  "block.minecraft.orange_concrete": "بتن نارنجی",
  "block.minecraft.orange_concrete_powder": "پودر بتن نارنجی",
  "block.minecraft.orange_glazed_terracotta": "سفال لعاب داده شده نارنجی",
  "block.minecraft.orange_shulker_box": "جعبه نارنجی شالکر",
  "block.minecraft.orange_stained_glass": "شيشه نارنجی رنگ",
  "block.minecraft.orange_stained_glass_pane": "شيشه پنجره نارنجی رنگ",
  "block.minecraft.orange_terracotta": "سفال نارنجی",
  "block.minecraft.orange_tulip": "گل لاله نارنجی",
  "block.minecraft.orange_wool": "پشم نارنجي",
  "block.minecraft.oxeye_daisy": "گل مينا",
  "block.minecraft.oxidized_chiseled_copper": "مس تراش خورده اکسيد شده",
  "block.minecraft.oxidized_copper": "مس اکسيد شده",
  "block.minecraft.oxidized_copper_bars": "ميله مس اکسید شده",
  "block.minecraft.oxidized_copper_bulb": "لامپ مس اکسيد شده",
  "block.minecraft.oxidized_copper_chain": "زنجير مس اکسید شده",
  "block.minecraft.oxidized_copper_chest": "صندوقچه مس اکسيد شده",
  "block.minecraft.oxidized_copper_door": "درب مس اکسيد شده",
  "block.minecraft.oxidized_copper_golem_statue": "مجسمه غول مسی اکسيد شده",
  "block.minecraft.oxidized_copper_grate": "قفس مس اکسيد شده",
  "block.minecraft.oxidized_copper_lantern": "فانوس مس اکسید شده",
  "block.minecraft.oxidized_copper_trapdoor": "دريچه مس اکسيد شده",
  "block.minecraft.oxidized_cut_copper": "مس برش خورده اکسيد شده",
  "block.minecraft.oxidized_cut_copper_slab": "نيمه مس برش خورده اکسيد شده",
  "block.minecraft.oxidized_cut_copper_stairs": "پله مس برش خورده اکسيد شده",
  "block.minecraft.oxidized_lightning_rod": "ميله برق گير اکسيد شده",
  "block.minecraft.packed_ice": "يخ فشرده",
  "block.minecraft.packed_mud": "کاهگِل",
  "block.minecraft.pale_hanging_moss": "خزه کمرنگ آویزان",
  "block.minecraft.pale_moss_block": "بلوک خزه کمرنگ",
  "block.minecraft.pale_moss_carpet": "فرش خزه کمرنگ",
  "block.minecraft.pale_oak_button": "دکمه بلوط کمرنگ",
  "block.minecraft.pale_oak_door": "درب بلوط کم رنگ",
  "block.minecraft.pale_oak_fence": "حصار بلوط کمرنگ",
  "block.minecraft.pale_oak_fence_gate": "دروازه حصار بلوط کم رنگ",
  "block.minecraft.pale_oak_hanging_sign": "تابلوی آویزان بلوط کمرنگ",
  "block.minecraft.pale_oak_leaves": "برگ های بلوط کمرنگ",
  "block.minecraft.pale_oak_log": "کنده بلوط کمرنگ",
  "block.minecraft.pale_oak_planks": "تخته های بلوط کمرنگ",
  "block.minecraft.pale_oak_pressure_plate": "صفحه فشار بلوط کمرنگ",
  "block.minecraft.pale_oak_sapling": "نهال بلوط کمرنگ",
  "block.minecraft.pale_oak_shelf": "قفسه کتاب بلوط کمرنگ",
  "block.minecraft.pale_oak_sign": "نهال بلوط کمرنگ",
  "block.minecraft.pale_oak_slab": "تخته بلوط کمرنگ",
  "block.minecraft.pale_oak_stairs": "پله های بلوط کمرنگ",
  "block.minecraft.pale_oak_trapdoor": "درب تله بلوط کمرنگ",
  "block.minecraft.pale_oak_wall_hanging_sign": "تابلوی آویز دیواری بلوط کم رنگ",
  "block.minecraft.pale_oak_wall_sign": "تابلوی دیواری بلوط کم رنگ",
  "block.minecraft.pale_oak_wood": "چوب بلوط کمرنگ",
  "block.minecraft.pearlescent_froglight": "نورباغه مرواريدی",
  "block.minecraft.peony": "گل پيونيا",
  "block.minecraft.petrified_oak_slab": "تخته بلوط خشک شده",
  "block.minecraft.piglin_head": "سر پيگلين",
  "block.minecraft.piglin_wall_head": "سر دیواری پیگلین",
  "block.minecraft.pink_banner": "پرچم صورتی",
  "block.minecraft.pink_bed": "تخت صورتی",
  "block.minecraft.pink_candle": "شمع صورتی",
  "block.minecraft.pink_candle_cake": "کيک با شمع صورتی",
  "block.minecraft.pink_carpet": "فرش صورتی",
  "block.minecraft.pink_concrete": "بتن صورتی",
  "block.minecraft.pink_concrete_powder": "پودر بتن صورتی",
  "block.minecraft.pink_glazed_terracotta": "سفال لعاب داده شده صورتی",
  "block.minecraft.pink_petals": "گلبرگ صورتی",
  "block.minecraft.pink_shulker_box": "جعبه صورتی شالکر",
  "block.minecraft.pink_stained_glass": "شيشه صورتی رنگ",
  "block.minecraft.pink_stained_glass_pane": "شيشه پنجره صورتی رنگ",
  "block.minecraft.pink_terracotta": "سفال صورتی",
  "block.minecraft.pink_tulip": "گل لاله صورتی",
  "block.minecraft.pink_wool": "پشم صورتي",
  "block.minecraft.piston": "پيستون",
  "block.minecraft.piston_head": "سر پيستون",
  "block.minecraft.pitcher_crop": "شاخه گياه کوزه‌دار",
  "block.minecraft.pitcher_plant": "گياه کوزه‌دار",
  "block.minecraft.player_head": "سر بازيکن",
  "block.minecraft.player_head.named": "سر %s",
  "block.minecraft.player_wall_head": "سر ديواری بازيکن",
  "block.minecraft.podzol": "گياخاک",
  "block.minecraft.pointed_dripstone": "چکنده‌سنگ جهت‌دار",
  "block.minecraft.polished_andesite": "آندزيت صيقلی",
  "block.minecraft.polished_andesite_slab": "نيمه آندزيت صيقلی",
  "block.minecraft.polished_andesite_stairs": "پله آندزيت صيقلی",
  "block.minecraft.polished_basalt": "بازالت صيقلی",
  "block.minecraft.polished_blackstone": "سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_brick_slab": "نيمه آجر سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_brick_stairs": "پله آجر سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_brick_wall": "ديوار آجر سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_bricks": "آجر سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_button": "دکمه‌ی سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_pressure_plate": "صفحه فشاری سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_slab": "نيمه سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_stairs": "پله سياه‌سنگ صيقلی",
  "block.minecraft.polished_blackstone_wall": "ديوار سياه‌سنگ صيقلی",
  "block.minecraft.polished_deepslate": "سنگ عميق صيقلی",
  "block.minecraft.polished_deepslate_slab": "نيمه سنگ عميق صيقلی",
  "block.minecraft.polished_deepslate_stairs": "پله سنگ عميق صيقلی",
  "block.minecraft.polished_deepslate_wall": "ديوار سنگ عميق صيقلی",
  "block.minecraft.polished_diorite": "ديوريت صيقلی",
  "block.minecraft.polished_diorite_slab": "نيمه ديوريت صيقلی",
  "block.minecraft.polished_diorite_stairs": "پله ديوريت صيقلی",
  "block.minecraft.polished_granite": "گرانيت صيقلی",
  "block.minecraft.polished_granite_slab": "نيمه گرانيت صيقلی",
  "block.minecraft.polished_granite_stairs": "پله گرانيت صيقلی",
  "block.minecraft.polished_tuff": "سنگ خاکستر صيقلی",
  "block.minecraft.polished_tuff_slab": "نيمه سنگ خاکستر صيقلی",
  "block.minecraft.polished_tuff_stairs": "پله سنگ خاکستر صيقلی",
  "block.minecraft.polished_tuff_wall": "ديوار سنگ خاکستر صيقلی",
  "block.minecraft.poppy": "گل شقايق",
  "block.minecraft.potatoes": "سيب زميني ها",
  "block.minecraft.potted_acacia_sapling": "نهال اقاقيا گلدانی",
  "block.minecraft.potted_allium": "گل‌سير گلدانی",
  "block.minecraft.potted_azalea_bush": "گلدان آزالیا",
  "block.minecraft.potted_azure_bluet": "گل هاستونيا گلدانی",
  "block.minecraft.potted_bamboo": "بامبو گلدانی",
  "block.minecraft.potted_birch_sapling": "نهال توس گلدانی",
  "block.minecraft.potted_blue_orchid": "ارکيده آبی گلدانی",
  "block.minecraft.potted_brown_mushroom": "قارچ قهوه‌ای گلدانی",
  "block.minecraft.potted_cactus": "کاکتوس گلدانی",
  "block.minecraft.potted_cherry_sapling": "نهال گيلاس گلدانی",
  "block.minecraft.potted_closed_eyeblossom": "شکوفه‌چشم بسته داخل گلدان",
  "block.minecraft.potted_cornflower": "گل گندم گلدانی",
  "block.minecraft.potted_crimson_fungus": "قارچ کريمسون داخل گلدان",
  "block.minecraft.potted_crimson_roots": "ریشه های کريمسون داخل گلدان",
  "block.minecraft.potted_dandelion": "قاصدک گلدانی",
  "block.minecraft.potted_dark_oak_sapling": "نهال بلوط تيره گلدانی",
  "block.minecraft.potted_dead_bush": "بوته مرده گلدانی",
  "block.minecraft.potted_fern": "سرخس گلدانی",
  "block.minecraft.potted_flowering_azalea_bush": "گلدان آزالیا گل‌دهنده",
  "block.minecraft.potted_golden_dandelion": "قاصدک طلايی گلدانی",
  "block.minecraft.potted_jungle_sapling": "نهال جنگلی گلدانی",
  "block.minecraft.potted_lily_of_the_valley": "زنبق گلدانی",
  "block.minecraft.potted_mangrove_propagule": "جوانه گلدانی درخت حرا",
  "block.minecraft.potted_oak_sapling": "نهال بلوط گلدانی",
  "block.minecraft.potted_open_eyeblossom": "شکوفه‌چشم باز داخل گلدان",
  "block.minecraft.potted_orange_tulip": "لاله نارنجی گلدانی",
  "block.minecraft.potted_oxeye_daisy": "گل مینا گلدانی",
  "block.minecraft.potted_pale_oak_sapling": "نهال بلوط کمرنگ گلدانی",
  "block.minecraft.potted_pink_tulip": "لاله صورتی گلدانی",
  "block.minecraft.potted_poppy": "شقايق گلدانی",
  "block.minecraft.potted_red_mushroom": "قارچ قرمز گلدانی",
  "block.minecraft.potted_red_tulip": "لاله قرمز گلدانی",
  "block.minecraft.potted_spruce_sapling": "نهال کاج گلدانی",
  "block.minecraft.potted_torchflower": "گل مشعلی گلدانی",
  "block.minecraft.potted_warped_fungus": "قارچ پيچ‌خورده‌ی داخل گلدان",
  "block.minecraft.potted_warped_roots": "ریشه های پيچ‌خورده‌ی داخل گلدان",
  "block.minecraft.potted_white_tulip": "لاله سفيد گلدانی",
  "block.minecraft.potted_wither_rose": "گل ويدر گلدانی",
  "block.minecraft.powder_snow": "پودر برف",
  "block.minecraft.powder_snow_cauldron": "سطل پودر برف",
  "block.minecraft.powered_rail": "ريل قدرتی",
  "block.minecraft.prismarine": "منشور دريايی",
  "block.minecraft.prismarine_brick_slab": "تخته آجر منشور دريايی",
  "block.minecraft.prismarine_brick_stairs": "پله آجر منشور دريايی",
  "block.minecraft.prismarine_bricks": "آجر منشور دريايی",
  "block.minecraft.prismarine_slab": "تخته منشور دريايی",
  "block.minecraft.prismarine_stairs": "پله منشور دريايی",
  "block.minecraft.prismarine_wall": "ديوار منشور دريايی",
  "block.minecraft.pumpkin": "کدوتنبل",
  "block.minecraft.pumpkin_stem": "ساقه کدو",
  "block.minecraft.purple_banner": "پرچم بنفش",
  "block.minecraft.purple_bed": "تخت بنفش",
  "block.minecraft.purple_candle": "شمع بنفش",
  "block.minecraft.purple_candle_cake": "کيک با شمع بنفش",
  "block.minecraft.purple_carpet": "فرش بنفش",
  "block.minecraft.purple_concrete": "بتن بنفش",
  "block.minecraft.purple_concrete_powder": "پودر بتن بنفش",
  "block.minecraft.purple_glazed_terracotta": "سفال لعاب داده شده بنفش",
  "block.minecraft.purple_shulker_box": "جعبه بنفش شالکر",
  "block.minecraft.purple_stained_glass": "شيشه بنفش رنگ",
  "block.minecraft.purple_stained_glass_pane": "شيشه پنجره بنفش رنگ",
  "block.minecraft.purple_terracotta": "سفال بنفش",
  "block.minecraft.purple_wool": "پشم بنفش",
  "block.minecraft.purpur_block": "بلوک کبود",
  "block.minecraft.purpur_pillar": "بلوک ستون کبود",
  "block.minecraft.purpur_slab": "قطعه نيمه کبود",
  "block.minecraft.purpur_stairs": "پله کبود",
  "block.minecraft.quartz_block": "بلوک کوارتز",
  "block.minecraft.quartz_bricks": "آجر کوارتزی",
  "block.minecraft.quartz_pillar": "ستون کوارتز",
  "block.minecraft.quartz_slab": "نيمه بلوک کوارتز",
  "block.minecraft.quartz_stairs": "پله کوارتز",
  "block.minecraft.rail": "ريل",
  "block.minecraft.raw_copper_block": "بلوک مس خام",
  "block.minecraft.raw_gold_block": "بلوک طلای خام",
  "block.minecraft.raw_iron_block": "بلوک آهن خام",
  "block.minecraft.red_banner": "پرچم قرمز",
  "block.minecraft.red_bed": "تخت قرمز",
  "block.minecraft.red_candle": "شمع قرمز",
  "block.minecraft.red_candle_cake": "کيک با شمع قرمز",
  "block.minecraft.red_carpet": "فرش قرمز",
  "block.minecraft.red_concrete": "بتن قرمز",
  "block.minecraft.red_concrete_powder": "پودر بتن قرمز",
  "block.minecraft.red_glazed_terracotta": "سفال لعاب داده شده قرمز",
  "block.minecraft.red_mushroom": "قارچ قرمز",
  "block.minecraft.red_mushroom_block": "بلوک قارچ قرمز",
  "block.minecraft.red_nether_brick_slab": "نيمه آجر ندری قرمز",
  "block.minecraft.red_nether_brick_stairs": "پله آجر ندری قرمز",
  "block.minecraft.red_nether_brick_wall": "ديوار آجر ندری قرمز",
  "block.minecraft.red_nether_bricks": "آجر ندری قرمز",
  "block.minecraft.red_sand": "ماسه قرمز",
  "block.minecraft.red_sandstone": "ماسه سنگ قرمز",
  "block.minecraft.red_sandstone_slab": "نيمه ماسه سنگ قرمز",
  "block.minecraft.red_sandstone_stairs": "پله ماسه سنگ قرمز",
  "block.minecraft.red_sandstone_wall": "ديوار ماسه سنگ قرمز",
  "block.minecraft.red_shulker_box": "جعبه قرمز شالکر",
  "block.minecraft.red_stained_glass": "شيشه قرمز رنگ",
  "block.minecraft.red_stained_glass_pane": "شيشه پنجره قرمز رنگ",
  "block.minecraft.red_terracotta": "سفال قرمز",
  "block.minecraft.red_tulip": "گل لاله قرمز",
  "block.minecraft.red_wool": "پشم قرمز",
  "block.minecraft.redstone_block": "بلوک ردستون",
  "block.minecraft.redstone_lamp": "لامپ ردستونی",
  "block.minecraft.redstone_ore": "سنگ معدن ردستون",
  "block.minecraft.redstone_torch": "مشعل ردستونی",
  "block.minecraft.redstone_wall_torch": "مشعل ردستون ديواری",
  "block.minecraft.redstone_wire": "پودر ردستون",
  "block.minecraft.reinforced_deepslate": "سنگ عميق مستحکم",
  "block.minecraft.repeater": "تکرارکننده ردستونی",
  "block.minecraft.repeating_command_block": "بلاک فرمان تکرار کننده",
  "block.minecraft.resin_block": "بلوک صمغ",
  "block.minecraft.resin_brick_slab": "نيمه آجر صمغ",
  "block.minecraft.resin_brick_stairs": "پله آجر صمغ",
  "block.minecraft.resin_brick_wall": "ديوار آجر صمغ",
  "block.minecraft.resin_bricks": "آجر صمغ",
  "block.minecraft.resin_clump": "قپه صمغ",
  "block.minecraft.respawn_anchor": "پايه احضار مجدد",
  "block.minecraft.rooted_dirt": "خاک ريشه‌دار",
  "block.minecraft.rose_bush": "بوته رز",
  "block.minecraft.sand": "ماسه",
  "block.minecraft.sandstone": "ماسه سنگ",
  "block.minecraft.sandstone_slab": "نيمه ماسه سنگ",
  "block.minecraft.sandstone_stairs": "پله ماسه سنگي",
  "block.minecraft.sandstone_wall": "ديوار ماسه سنگي",
  "block.minecraft.scaffolding": "داربست",
  "block.minecraft.sculk": "اسکالک",
  "block.minecraft.sculk_catalyst": "اسکالک تسريعگر",
  "block.minecraft.sculk_sensor": "حسگر اسکالک",
  "block.minecraft.sculk_shrieker": "اسکالک فريادگر",
  "block.minecraft.sculk_vein": "رگبرگ اسکالک",
  "block.minecraft.sea_lantern": "فانوس دريايی",
  "block.minecraft.sea_pickle": "خیارشور دريايی",
  "block.minecraft.seagrass": "علف دريايی",
  "block.minecraft.set_spawn": "نقطه بازگشت تنظيم شد",
  "block.minecraft.short_dry_grass": "چمن خشک کوتاه",
  "block.minecraft.short_grass": "علف کوتاه",
  "block.minecraft.shroomlight": "چراغ قارچی",
  "block.minecraft.shulker_box": "جعبه شالکر",
  "block.minecraft.skeleton_skull": "جمجمه اسکلت",
  "block.minecraft.skeleton_wall_skull": "جمجمه ديواری اسکلت",
  "block.minecraft.slime_block": "بلوک لجن",
  "block.minecraft.small_amethyst_bud": "جوانه کوچک ياقوت ارغوانی",
  "block.minecraft.small_dripleaf": "چکه‌برگ کوچک",
  "block.minecraft.smithing_table": "ميز آهنگری",
  "block.minecraft.smoker": "اسموکر",
  "block.minecraft.smooth_basalt": "بازالت صاف",
  "block.minecraft.smooth_quartz": "بلوک کوارتز صاف",
  "block.minecraft.smooth_quartz_slab": "نيمه بلوک کوارتز صاف",
  "block.minecraft.smooth_quartz_stairs": "پله کوارتز صاف",
  "block.minecraft.smooth_red_sandstone": "ماسه سنگ قرمز صاف",
  "block.minecraft.smooth_red_sandstone_slab": "نيمه ماسه سنگ قرمز صاف",
  "block.minecraft.smooth_red_sandstone_stairs": "پله ماسه سنگ قرمز صاف",
  "block.minecraft.smooth_sandstone": "ماسه سنگ صاف",
  "block.minecraft.smooth_sandstone_slab": "نيمه ماسه سنگ صاف",
  "block.minecraft.smooth_sandstone_stairs": "پله ماسه سنگ صاف",
  "block.minecraft.smooth_stone": "سنگ صاف",
  "block.minecraft.smooth_stone_slab": "نيمه سنگ صاف",
  "block.minecraft.sniffer_egg": "تخم بويشگر",
  "block.minecraft.snow": "برف",
  "block.minecraft.snow_block": "بلوک برف",
  "block.minecraft.soul_campfire": "کنده‌آتش ارواح",
  "block.minecraft.soul_fire": "آتش ارواح",
  "block.minecraft.soul_lantern": "فانوس ارواح",
  "block.minecraft.soul_sand": "شن ارواح",
  "block.minecraft.soul_soil": "خاک ارواح",
  "block.minecraft.soul_torch": "مشعل ارواح",
  "block.minecraft.soul_wall_torch": "مشعل ارواح ديواری",
  "block.minecraft.spawn.not_valid": "شما تختخواب خانه یا لنگر بازگشت ندارید، یا آنها خراب شده اند",
  "block.minecraft.spawner": "احضارگر هيولا",
  "block.minecraft.spawner.desc1": "تعاملات با تخم های توليد:",
  "block.minecraft.spawner.desc2": "نوع موب را مشخص می‌کند",
  "block.minecraft.sponge": "اسفنج",
  "block.minecraft.spore_blossom": "شکوفه هاگ",
  "block.minecraft.spruce_button": "دکمه کاج",
  "block.minecraft.spruce_door": "درب کاج",
  "block.minecraft.spruce_fence": "نرده کاج",
  "block.minecraft.spruce_fence_gate": "درب نرده کاج",
  "block.minecraft.spruce_hanging_sign": "تابلو آويزان چوب کاج",
  "block.minecraft.spruce_leaves": "برگ صنوبر",
  "block.minecraft.spruce_log": "تنه درخت کاج",
  "block.minecraft.spruce_planks": "الوار کاج",
  "block.minecraft.spruce_pressure_plate": "صفحه فشاری کاج",
  "block.minecraft.spruce_sapling": "نهال درخت صنوبر",
  "block.minecraft.spruce_shelf": "قفسه کتاب کاج",
  "block.minecraft.spruce_sign": "تابلو چوب کاج",
  "block.minecraft.spruce_slab": "تخته کاج",
  "block.minecraft.spruce_stairs": "پله کاج",
  "block.minecraft.spruce_trapdoor": "دريچه‌ی کاج",
  "block.minecraft.spruce_wall_hanging_sign": "تابلو آويزان ديوار چوب کاج",
  "block.minecraft.spruce_wall_sign": "تابلو ديواری چوب کاج",
  "block.minecraft.spruce_wood": "چوب صنوبر",
  "block.minecraft.sticky_piston": "پيستون چسبناک",
  "block.minecraft.stone": "سنگ",
  "block.minecraft.stone_brick_slab": "نيمه آجرسنگ",
  "block.minecraft.stone_brick_stairs": "پله آجرسنگ",
  "block.minecraft.stone_brick_wall": "ديوار آجرسنگ",
  "block.minecraft.stone_bricks": "آجرسنگ",
  "block.minecraft.stone_button": "دکمه سنگی",
  "block.minecraft.stone_pressure_plate": "صفحه فشاری سنگی",
  "block.minecraft.stone_slab": "نيمه سنگ",
  "block.minecraft.stone_stairs": "پله سنگی",
  "block.minecraft.stonecutter": "سنگ تراش",
  "block.minecraft.stripped_acacia_log": "تنه برهنه اقاقيا",
  "block.minecraft.stripped_acacia_wood": "چوب برهنه اقاقيا",
  "block.minecraft.stripped_bamboo_block": "بلوک بامبوی برهنه",
  "block.minecraft.stripped_birch_log": "تنه برهنه توس",
  "block.minecraft.stripped_birch_wood": "چوب برهنه توس",
  "block.minecraft.stripped_cherry_log": "تنه برهنه چوب گيلاس",
  "block.minecraft.stripped_cherry_wood": "چوب برهنه گيلاس",
  "block.minecraft.stripped_crimson_hyphae": "چوب برهنه کريمسون",
  "block.minecraft.stripped_crimson_stem": "تنه برهنه کريمسون",
  "block.minecraft.stripped_dark_oak_log": "تنه برهنه بلوط تيره",
  "block.minecraft.stripped_dark_oak_wood": "چوب برهنه بلوط سياه",
  "block.minecraft.stripped_jungle_log": "تنه برهنه جنگلی",
  "block.minecraft.stripped_jungle_wood": "چوب برهنه جنگلی",
  "block.minecraft.stripped_mangrove_log": "تنه برهنه درخت حرا",
  "block.minecraft.stripped_mangrove_wood": "چوب برهنه درخت حرا",
  "block.minecraft.stripped_oak_log": "تنه برهنه بلوط",
  "block.minecraft.stripped_oak_wood": "چوب برهنه بلوط",
  "block.minecraft.stripped_pale_oak_log": "کنده درخت بلوط کمرنگ",
  "block.minecraft.stripped_pale_oak_wood": "چوب بریده بلوط کمرنگ",
  "block.minecraft.stripped_spruce_log": "تنه برهنه کاج",
  "block.minecraft.stripped_spruce_wood": "چوب برهنه کاج",
  "block.minecraft.stripped_warped_hyphae": "چوب برهنه پیچ‌خورده",
  "block.minecraft.stripped_warped_stem": "تنه برهنه پيچ خورده",
  "block.minecraft.structure_block": "ساختار بلوک",
  "block.minecraft.structure_void": "ساختار خالی",
  "block.minecraft.sugar_cane": "نیشکر",
  "block.minecraft.sunflower": "گل آفتابگردان",
  "block.minecraft.suspicious_gravel": "ريگ مشکوک",
  "block.minecraft.suspicious_sand": "ماسه مشکوک",
  "block.minecraft.sweet_berry_bush": "بوته توت شيرين",
  "block.minecraft.tall_dry_grass": "چمن خشک بلند",
  "block.minecraft.tall_grass": "علف بلند",
  "block.minecraft.tall_seagrass": "علف دريايی بلند",
  "block.minecraft.target": "هدف",
  "block.minecraft.terracotta": "سفال",
  "block.minecraft.test_block": "بلوک آزمایشی",
  "block.minecraft.test_instance_block": "بلوک نمونه آزمایشی",
  "block.minecraft.tinted_glass": "شيشه دودی",
  "block.minecraft.tnt": "تي ان تي",
  "block.minecraft.tnt.disabled": "انفجار TNT غيرفعال شده",
  "block.minecraft.torch": "مشعل",
  "block.minecraft.torchflower": "گل مشعلی",
  "block.minecraft.torchflower_crop": "بوته گل مشعلی",
  "block.minecraft.trapped_chest": "صندوقچه تله گذاري",
  "block.minecraft.trial_spawner": "احضار کننده آزمايشگر",
  "block.minecraft.tripwire": "نخ تله",
  "block.minecraft.tripwire_hook": "گیره تله نخی",
  "block.minecraft.tube_coral": "مرجان لوله‌ای",
  "block.minecraft.tube_coral_block": "بلوک مرجان لوله‌ای",
  "block.minecraft.tube_coral_fan": "لوله ی بادبزن مرجانی",
  "block.minecraft.tube_coral_wall_fan": "ديوار لوله ای بادبزن مرجانی",
  "block.minecraft.tuff": "سنگ خاکستر",
  "block.minecraft.tuff_brick_slab": "نيمه آجرسنگ خاکستر",
  "block.minecraft.tuff_brick_stairs": "پله آجرسنگ خاکستر",
  "block.minecraft.tuff_brick_wall": "ديوار آجرسنگ خاکستر",
  "block.minecraft.tuff_bricks": "آجرسنگ خاکستر",
  "block.minecraft.tuff_slab": "نيمه سنگ خاکستر",
  "block.minecraft.tuff_stairs": "پله سنگ خاکستر",
  "block.minecraft.tuff_wall": "ديوار سنگ خاکستر",
  "block.minecraft.turtle_egg": "تخم لاک پشت",
  "block.minecraft.twisting_vines": "تاک های پيچنده",
  "block.minecraft.twisting_vines_plant": "گیاه تاک پيچنده",
  "block.minecraft.vault": "گنجينه",
  "block.minecraft.verdant_froglight": "نورباغه سبزفام",
  "block.minecraft.vine": "تاک ها",
  "block.minecraft.void_air": "هوای تهی",
  "block.minecraft.wall_torch": "مشعل ديواری",
  "block.minecraft.warped_button": "دکمه‌ی پيچ‌خورده",
  "block.minecraft.warped_door": "درب پيچ‌خورده",
  "block.minecraft.warped_fence": "نرده پيچ‌خورده",
  "block.minecraft.warped_fence_gate": "درب نرده پيچ‌خورده",
  "block.minecraft.warped_fungus": "قارچ پيچ‌خورده",
  "block.minecraft.warped_hanging_sign": "تابلو آويزان چوب پیچ‌خورده",
  "block.minecraft.warped_hyphae": "سرشاخه پيچ‌خورده",
  "block.minecraft.warped_nylium": "نيليوم پيچ‌خورده",
  "block.minecraft.warped_planks": "الوار پيچ‌خورده",
  "block.minecraft.warped_pressure_plate": "صفحه فشاری پيچ‌خورده",
  "block.minecraft.warped_roots": "ریشه های پيچ‌خورده",
  "block.minecraft.warped_shelf": "قفسه کتاب چوب پيچ خورده",
  "block.minecraft.warped_sign": "تابلوی چوب پيچ‌خورده",
  "block.minecraft.warped_slab": "نيمه بلوک پيچ‌خورده",
  "block.minecraft.warped_stairs": "پله چوب پيچ‌خورده",
  "block.minecraft.warped_stem": "ساقه پيچ‌خورده",
  "block.minecraft.warped_trapdoor": "دريچه‌ی پيچ‌خورده",
  "block.minecraft.warped_wall_hanging_sign": "تابلو آويزان ديوار چوب پیچ‌خورده",
  "block.minecraft.warped_wall_sign": "تابلو ديواری پيچ خورده",
  "block.minecraft.warped_wart_block": "بلوک زگيل پيچ‌خورده‌",
  "block.minecraft.water": "آب",
  "block.minecraft.water_cauldron": "ديگ آب",
  "block.minecraft.waxed_chiseled_copper": "مس تراش خورده واکس زده",
  "block.minecraft.waxed_copper_bars": "ميله مسی واکس زده",
  "block.minecraft.waxed_copper_block": "بلوک مس واکس زده شده",
  "block.minecraft.waxed_copper_bulb": "لامپ مس واکس زده",
  "block.minecraft.waxed_copper_chain": "زنجیر مسی واکس زده",
  "block.minecraft.waxed_copper_chest": "صندوقچه مس واکس زده",
  "block.minecraft.waxed_copper_door": "درب مس واکس زده",
  "block.minecraft.waxed_copper_golem_statue": "مجسمه غول مسی واکس زده",
  "block.minecraft.waxed_copper_grate": "قفس مس واکس زده",
  "block.minecraft.waxed_copper_lantern": "فانوس مسی واکس زده",
  "block.minecraft.waxed_copper_trapdoor": "دريچه مس واکس زده",
  "block.minecraft.waxed_cut_copper": "مس واکس زده برش خورده",
  "block.minecraft.waxed_cut_copper_slab": "نيمه مس واکس زده برش خورده",
  "block.minecraft.waxed_cut_copper_stairs": "پله مس واکس زده برش خورده",
  "block.minecraft.waxed_exposed_chiseled_copper": "مس تراش خورده هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper": "مس واکس زده هوا ديده",
  "block.minecraft.waxed_exposed_copper_bars": "ميله مسی هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper_bulb": "لامپ مس هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper_chain": "زنجیر مسی هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper_chest": "صندوقچه مس هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper_door": "درب مس هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper_golem_statue": "مجسمه غول مسی هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper_grate": "قفس مس هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper_lantern": "فانوس مسی هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_copper_trapdoor": "دريچه مس هوا ديده واکس زده",
  "block.minecraft.waxed_exposed_cut_copper": "مس برش خورده واکس زده هوا ديده",
  "block.minecraft.waxed_exposed_cut_copper_slab": "نيمه مس برش خورده واکس زده هوا ديده",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "پله مس برش خورده واکس زده هوا ديده",
  "block.minecraft.waxed_exposed_lightning_rod": "ميله برق گير هوا ديده واکس زده",
  "block.minecraft.waxed_lightning_rod": "ميله برق گير واکس زده",
  "block.minecraft.waxed_oxidized_chiseled_copper": "مس تراش خورده اکسيد شده واکس زده",
  "block.minecraft.waxed_oxidized_copper": "مس واکس زده اکسيد شده",
  "block.minecraft.waxed_oxidized_copper_bars": "میله مس اکسید شده واکس زده",
  "block.minecraft.waxed_oxidized_copper_bulb": "لامپ مس اکسيد شده واکس زده",
  "block.minecraft.waxed_oxidized_copper_chain": "زنجیر مس اکسید شده واکس زده",
  "block.minecraft.waxed_oxidized_copper_chest": "صندوقچه مس اکسيد شده واکس زده",
  "block.minecraft.waxed_oxidized_copper_door": "درب مس اکسيد شده واکس زده",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "مجسمه غول مسی اکسيد شده واکس زده",
  "block.minecraft.waxed_oxidized_copper_grate": "قفس مس اکسيد شده واکس زده",
  "block.minecraft.waxed_oxidized_copper_lantern": "فانوس مس اکسید شده واکس زده",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "دريچه مس اکسيد شده واکس زده",
  "block.minecraft.waxed_oxidized_cut_copper": "مس برش خورده واکس زده اکسيد شده",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "نيمه مس برش خورده واکس زده اکسيد شده",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "پله مس برش خورده واکس زده اکسيد شده",
  "block.minecraft.waxed_oxidized_lightning_rod": "ميله برق گير اکسيد شده واکس زده",
  "block.minecraft.waxed_weathered_chiseled_copper": "مس تراش خورده هوازده واکس زده",
  "block.minecraft.waxed_weathered_copper": "مس واکس زده هوازده",
  "block.minecraft.waxed_weathered_copper_bars": "ميله مسی هوازده واکس زده",
  "block.minecraft.waxed_weathered_copper_bulb": "لامپ مس هوازده واکس زده",
  "block.minecraft.waxed_weathered_copper_chain": "زنجیر مسی هوازده واکس زده",
  "block.minecraft.waxed_weathered_copper_chest": "صندوقچه مس هوازده واکس زده",
  "block.minecraft.waxed_weathered_copper_door": "درب مس هوازده واکس زده",
  "block.minecraft.waxed_weathered_copper_golem_statue": "مجسمه غول مسی هوازده واکس زده",
  "block.minecraft.waxed_weathered_copper_grate": "قفس مس هوازده واکس زده",
  "block.minecraft.waxed_weathered_copper_lantern": "فانوس مسی هوازده واکس شده",
  "block.minecraft.waxed_weathered_copper_trapdoor": "دريچه مس هوازده واکس زده",
  "block.minecraft.waxed_weathered_cut_copper": "مس برش خورده واکس زده هوازده",
  "block.minecraft.waxed_weathered_cut_copper_slab": "نيمه مس برش خورده واکس زده هوازده",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "پله مس برش خورده واکس زده هوازده",
  "block.minecraft.waxed_weathered_lightning_rod": "ميله برق گير هوازده واکس زده",
  "block.minecraft.weathered_chiseled_copper": "مس تراش خورده هوازده",
  "block.minecraft.weathered_copper": "مس هوازده",
  "block.minecraft.weathered_copper_bars": "ميله مسی هوازده",
  "block.minecraft.weathered_copper_bulb": "لامپ مس هوازده",
  "block.minecraft.weathered_copper_chain": "زنجیر مسی هوازده",
  "block.minecraft.weathered_copper_chest": "صندوقچه مس هوازده",
  "block.minecraft.weathered_copper_door": "درب مس هوازده",
  "block.minecraft.weathered_copper_golem_statue": "مجسمه غول مسی هوازده",
  "block.minecraft.weathered_copper_grate": "قفس مس هوازده",
  "block.minecraft.weathered_copper_lantern": "فانوس مسی هوازده",
  "block.minecraft.weathered_copper_trapdoor": "دريچه مس هوازده",
  "block.minecraft.weathered_cut_copper": "مس برش خورده هوازده",
  "block.minecraft.weathered_cut_copper_slab": "نيمه مس برش خورده هوازده",
  "block.minecraft.weathered_cut_copper_stairs": "پله مس برش خورده هوازده",
  "block.minecraft.weathered_lightning_rod": "ميله برق گير هوازده",
  "block.minecraft.weeping_vines": "پيچک گریان",
  "block.minecraft.weeping_vines_plant": "گیاه تاک مجنون",
  "block.minecraft.wet_sponge": "اسفنج خيس",
  "block.minecraft.wheat": "خوشه گندم",
  "block.minecraft.white_banner": "پرچم سفيد",
  "block.minecraft.white_bed": "تخت سفيد",
  "block.minecraft.white_candle": "شمع سفيد",
  "block.minecraft.white_candle_cake": "کيک با شمع سفيد",
  "block.minecraft.white_carpet": "فرش سفيد",
  "block.minecraft.white_concrete": "بتن سفيد",
  "block.minecraft.white_concrete_powder": "پودر بتن سفيد",
  "block.minecraft.white_glazed_terracotta": "سفال لعاب داده شده سفيد",
  "block.minecraft.white_shulker_box": "جعبه سفيد شالکر",
  "block.minecraft.white_stained_glass": "شيشه سفيد رنگ",
  "block.minecraft.white_stained_glass_pane": "شيشه پنجره سفيد رنگ",
  "block.minecraft.white_terracotta": "سفال سفيد",
  "block.minecraft.white_tulip": "گل لاله سفيد",
  "block.minecraft.white_wool": "پشم سفيد",
  "block.minecraft.wildflowers": "گل‌های وحشی",
  "block.minecraft.wither_rose": "گل ويدر",
  "block.minecraft.wither_skeleton_skull": "جمجمه اسکلت ویدر",
  "block.minecraft.wither_skeleton_wall_skull": "جمجمه ویدر روی ديوار",
  "block.minecraft.yellow_banner": "پرچم زرد",
  "block.minecraft.yellow_bed": "تخت زرد",
  "block.minecraft.yellow_candle": "شمع زرد",
  "block.minecraft.yellow_candle_cake": "کيک با شمع زرد",
  "block.minecraft.yellow_carpet": "فرش زرد",
  "block.minecraft.yellow_concrete": "بتن زرد",
  "block.minecraft.yellow_concrete_powder": "پودر بتن زرد",
  "block.minecraft.yellow_glazed_terracotta": "سفال لعاب داده شده زرد",
  "block.minecraft.yellow_shulker_box": "جعبه زرد شالکر",
  "block.minecraft.yellow_stained_glass": "شيشه زرد رنگ",
  "block.minecraft.yellow_stained_glass_pane": "شيشه پنجره زرد رنگ",
  "block.minecraft.yellow_terracotta": "سفال زرد",
  "block.minecraft.yellow_wool": "پشم زرد",
  "block.minecraft.zombie_head": "سر زامبی",
  "block.minecraft.zombie_wall_head": "سر ديواری زامبی",
  "item.minecraft.acacia_boat": "قايق اقاقيا",
  "item.minecraft.acacia_chest_boat": "قايق اقاقيا با صندوقچه",
  "item.minecraft.allay_spawn_egg": "تخم توليد هميار",
  "item.minecraft.amethyst_shard": "تکه ياقوت ارغوانی",
  "item.minecraft.angler_pottery_shard": "قطعه کوزه‌گری ماهيگير",
  "item.minecraft.angler_pottery_sherd": "قطعه کوزه‌گری ماهيگير",
  "item.minecraft.apple": "سيب",
  "item.minecraft.archer_pottery_shard": "قطعه کوزه‌گری کماندار",
  "item.minecraft.archer_pottery_sherd": "قطعه کوزه‌گری کماندار",
  "item.minecraft.armadillo_scute": "پوسته آرماديلو",
  "item.minecraft.armadillo_spawn_egg": "تخم توليد آرماديلو",
  "item.minecraft.armor_stand": "پايه زره پوش",
  "item.minecraft.arms_up_pottery_shard": "قطعه کوزه‌گری دستان بالا",
  "item.minecraft.arms_up_pottery_sherd": "قطعه کوزه‌گری دستان بالا",
  "item.minecraft.arrow": "تير",
  "item.minecraft.axolotl_bucket": "سطل اکسولوتل",
  "item.minecraft.axolotl_spawn_egg": "تخم تولید اکسلاتل",
  "item.minecraft.baked_potato": "سیب زمینی پخته",
  "item.minecraft.bamboo_chest_raft": "کلک بامبو با صندوقچه",
  "item.minecraft.bamboo_raft": "کلک بامبو",
  "item.minecraft.bat_spawn_egg": "تخم توليد خفاش",
  "item.minecraft.bee_spawn_egg": "تخم توليد زنبور",
  "item.minecraft.beef": "گوشت گاو",
  "item.minecraft.beetroot": "چغندر",
  "item.minecraft.beetroot_seeds": "بذر چغندر",
  "item.minecraft.beetroot_soup": "سوپ چغندر",
  "item.minecraft.birch_boat": "قايق توس",
  "item.minecraft.birch_chest_boat": "قايق توس با صندوقچه",
  "item.minecraft.black_bundle": "بقچه سیاه",
  "item.minecraft.black_dye": "رنگ سياه",
  "item.minecraft.black_harness": "افسار مشکی",
  "item.minecraft.blade_pottery_shard": "قطعه کوزه‌گری تيغ",
  "item.minecraft.blade_pottery_sherd": "قطعه کوزه‌گری تيغ",
  "item.minecraft.blaze_powder": "جرقه شعله افروز",
  "item.minecraft.blaze_rod": "ميله آتشين",
  "item.minecraft.blaze_spawn_egg": "تخم توليد شعله افروز",
  "item.minecraft.blue_bundle": "بقچه آبی",
  "item.minecraft.blue_dye": "رنگ آبی",
  "item.minecraft.blue_egg": "تخم آبی",
  "item.minecraft.blue_harness": "افسار آبی",
  "item.minecraft.bogged_spawn_egg": "تخم توليد مرداب‌زاد",
  "item.minecraft.bolt_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "تراش زره طرح تير",
  "item.minecraft.bone": "استخوان",
  "item.minecraft.bone_meal": "بارورگر",
  "item.minecraft.book": "کتاب",
  "item.minecraft.bordure_indented_banner_pattern": "طرح بنر حاشيه مواج",
  "item.minecraft.bow": "کمان",
  "item.minecraft.bowl": "کاسه",
  "item.minecraft.bread": "نان",
  "item.minecraft.breeze_rod": "ميله نسيم‌گون",
  "item.minecraft.breeze_spawn_egg": "تخم احضار طوفان",
  "item.minecraft.brewer_pottery_shard": "قطعه کوزه‌گری معجون‌ساز",
  "item.minecraft.brewer_pottery_sherd": "قطعه کوزه‌گری معجون‌ساز",
  "item.minecraft.brewing_stand": "معجون‌ساز",
  "item.minecraft.brick": "آجر",
  "item.minecraft.brown_bundle": "بقچه قهوه‌ای",
  "item.minecraft.brown_dye": "رنگ قهوه‌ای",
  "item.minecraft.brown_egg": "تخم قهوه‌ای",
  "item.minecraft.brown_harness": "افسار قهوه‌ای",
  "item.minecraft.brush": "بُرِس",
  "item.minecraft.bucket": "سطل",
  "item.minecraft.bundle": "کيسه",
  "item.minecraft.bundle.empty": "خالی",
  "item.minecraft.bundle.empty.description": "میتواند ترکيبی از ظرفيت آيتم های مختلف را باهم نگه دارد",
  "item.minecraft.bundle.full": "پُر",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "قطعه کوزه‌گری شعله",
  "item.minecraft.burn_pottery_sherd": "قطعه کوزه‌گری آتش",
  "item.minecraft.camel_husk_spawn_egg": "تخم توليد شتر زامبی",
  "item.minecraft.camel_spawn_egg": "تخم توليد شتر",
  "item.minecraft.carrot": "هويج",
  "item.minecraft.carrot_on_a_stick": "هويج روی قلاب",
  "item.minecraft.cat_spawn_egg": "تخم توليد گربه",
  "item.minecraft.cauldron": "ديگ",
  "item.minecraft.cave_spider_spawn_egg": "تخم توليد عنکبوت غاری",
  "item.minecraft.chainmail_boots": "چکمه زنجيری",
  "item.minecraft.chainmail_chestplate": "زره زنجيری",
  "item.minecraft.chainmail_helmet": "کلاهخود زنجيری",
  "item.minecraft.chainmail_leggings": "شلوار زنجيری",
  "item.minecraft.charcoal": "زغال چوب",
  "item.minecraft.cherry_boat": "قايق چوب گيلاس",
  "item.minecraft.cherry_chest_boat": "قايق چوب گيلاس با صندوقچه",
  "item.minecraft.chest_minecart": "ماشين معدن با صندوقچه",
  "item.minecraft.chicken": "مرغ خام",
  "item.minecraft.chicken_spawn_egg": "تخم توليد مرغ",
  "item.minecraft.chorus_fruit": "ميوه کُر",
  "item.minecraft.clay_ball": "توده سفال",
  "item.minecraft.clock": "ساعت",
  "item.minecraft.coal": "زغال سنگ",
  "item.minecraft.coast_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.coast_armor_trim_smithing_template.new": "تراش زره طرح کرانه دريا",
  "item.minecraft.cocoa_beans": "دانه کاکائو",
  "item.minecraft.cod": "روغن‌ماهی خام",
  "item.minecraft.cod_bucket": "سطل روغن‌ماهی",
  "item.minecraft.cod_spawn_egg": "تخم توليد ماهی",
  "item.minecraft.command_block_minecart": "ماشين معدن با بلوک دستور",
  "item.minecraft.compass": "قطب نما",
  "item.minecraft.cooked_beef": "گوشت پخته گاو",
  "item.minecraft.cooked_chicken": "گوشت پخته مرغ",
  "item.minecraft.cooked_cod": "روغن‌ماهی پخته شده",
  "item.minecraft.cooked_mutton": "گوشت پخته گوسفند",
  "item.minecraft.cooked_porkchop": "گوشت پخته خوک",
  "item.minecraft.cooked_rabbit": "گوشت پخته خرگوش",
  "item.minecraft.cooked_salmon": "ماهی سالمون پخته",
  "item.minecraft.cookie": "بيسکوييت",
  "item.minecraft.copper_axe": "تبر مسی",
  "item.minecraft.copper_boots": "کفش مسی",
  "item.minecraft.copper_chestplate": "زره مسی",
  "item.minecraft.copper_golem_spawn_egg": "تخم توليد غول مسی",
  "item.minecraft.copper_helmet": "کلاهخود مسی",
  "item.minecraft.copper_hoe": "خيش مسی",
  "item.minecraft.copper_horse_armor": "زره مسی اسب",
  "item.minecraft.copper_ingot": "شمش مس",
  "item.minecraft.copper_leggings": "شلوار مسی",
  "item.minecraft.copper_nautilus_armor": "زره مسی ملوانک",
  "item.minecraft.copper_nugget": "ذره مس",
  "item.minecraft.copper_pickaxe": "کلنگ مسی",
  "item.minecraft.copper_shovel": "بيل مسی",
  "item.minecraft.copper_spear": "نیزه مسی",
  "item.minecraft.copper_sword": "شمشير مسی",
  "item.minecraft.cow_spawn_egg": "تخم توليد گاو",
  "item.minecraft.creaking_spawn_egg": "تخم تولید کريکينگ",
  "item.minecraft.creeper_banner_pattern": "طرح پرچم",
  "item.minecraft.creeper_banner_pattern.desc": "کریپر شارژ شده",
  "item.minecraft.creeper_banner_pattern.new": "طرح بنر شارژ کريپر",
  "item.minecraft.creeper_spawn_egg": "تخم توليد کريپر",
  "item.minecraft.crossbow": "کمان پولادی",
  "item.minecraft.crossbow.projectile": "شیء پرتابی:",
  "item.minecraft.crossbow.projectile.multiple": "پرتابه: %s x %s",
  "item.minecraft.crossbow.projectile.single": "پرتابه: %s",
  "item.minecraft.cyan_bundle": "بقچه فيروزه‌ای",
  "item.minecraft.cyan_dye": "رنگ فيروزه‌ای",
  "item.minecraft.cyan_harness": "افسار فیروزه‌ای",
  "item.minecraft.danger_pottery_shard": "قطعه کوزه‌گری خطر",
  "item.minecraft.danger_pottery_sherd": "قطعه خطرناک کوزه‌گری",
  "item.minecraft.dark_oak_boat": "قايق بلوط تيره",
  "item.minecraft.dark_oak_chest_boat": "قايق بلوط تيره با صندوقچه",
  "item.minecraft.debug_stick": "چوب ديباگ",
  "item.minecraft.debug_stick.empty": "%s هیچ خواصی ندارد",
  "item.minecraft.debug_stick.select": "انتخاب شده \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "%s تا %s",
  "item.minecraft.diamond": "الماس",
  "item.minecraft.diamond_axe": "تبر الماسی",
  "item.minecraft.diamond_boots": "چکمه الماسی",
  "item.minecraft.diamond_chestplate": "زره الماسی",
  "item.minecraft.diamond_helmet": "کلاهخود الماسی",
  "item.minecraft.diamond_hoe": "خيش الماسی",
  "item.minecraft.diamond_horse_armor": "زره الماسی اسب",
  "item.minecraft.diamond_leggings": "شلوار الماسی",
  "item.minecraft.diamond_nautilus_armor": "زره الماس ملوانک",
  "item.minecraft.diamond_pickaxe": "کلنگ الماسی",
  "item.minecraft.diamond_shovel": "بيل الماسی",
  "item.minecraft.diamond_spear": "نیزه الماس",
  "item.minecraft.diamond_sword": "شمشير الماسی",
  "item.minecraft.disc_fragment_5": "قطعه ديسک موسيقی",
  "item.minecraft.disc_fragment_5.desc": "ديسک موسيقی - 5",
  "item.minecraft.dolphin_spawn_egg": "تخم توليد دلفین",
  "item.minecraft.donkey_spawn_egg": "تخم توليد الاغ",
  "item.minecraft.dragon_breath": "نفس اژدها",
  "item.minecraft.dried_kelp": "جلبک دريايی خشک شده",
  "item.minecraft.drowned_spawn_egg": "تخم توليد غرق شده",
  "item.minecraft.dune_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.dune_armor_trim_smithing_template.new": "تراش زره طرح تَل ماسه",
  "item.minecraft.echo_shard": "تيغه طنين",
  "item.minecraft.egg": "تخم مرغ",
  "item.minecraft.elder_guardian_spawn_egg": "تخم توليد محافظ ارشد",
  "item.minecraft.elytra": "بال پوش",
  "item.minecraft.emerald": "زمرد",
  "item.minecraft.enchanted_book": "کتاب افسون شده",
  "item.minecraft.enchanted_golden_apple": "سيب طلايی جادويی",
  "item.minecraft.end_crystal": "کريستال پایان",
  "item.minecraft.ender_dragon_spawn_egg": "تخم توليد اژدهای فرجام",
  "item.minecraft.ender_eye": "چشم فرجام",
  "item.minecraft.ender_pearl": "گوهر فرجام",
  "item.minecraft.enderman_spawn_egg": "تخم توليد اندرمن",
  "item.minecraft.endermite_spawn_egg": "تخم توليد اندرمايت",
  "item.minecraft.evoker_spawn_egg": "تخم توليد فراخواننده",
  "item.minecraft.experience_bottle": "بطری تجربه",
  "item.minecraft.explorer_pottery_shard": "قطعه کوزه‌گری ماجراجو",
  "item.minecraft.explorer_pottery_sherd": "قطعه کوزه‌گری ماجراجوی",
  "item.minecraft.eye_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.eye_armor_trim_smithing_template.new": "تراش زره طرح چشم",
  "item.minecraft.feather": "پر",
  "item.minecraft.fermented_spider_eye": "چشم عنکبوت تخمیر شده",
  "item.minecraft.field_masoned_banner_pattern": "طرح بنر ديوار آجر",
  "item.minecraft.filled_map": "نقشه",
  "item.minecraft.fire_charge": "مهمات آتش",
  "item.minecraft.firework_rocket": "راکت آتشبازي",
  "item.minecraft.firework_rocket.flight": "مدت پرواز:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "گلوله باروت",
  "item.minecraft.firework_star.black": "مشکي",
  "item.minecraft.firework_star.blue": "آبی",
  "item.minecraft.firework_star.brown": "قهوه ای",
  "item.minecraft.firework_star.custom_color": "سفارشی",
  "item.minecraft.firework_star.cyan": "فيروزه ای",
  "item.minecraft.firework_star.fade_to": "محو شدن",
  "item.minecraft.firework_star.flicker": "چشمک زدن",
  "item.minecraft.firework_star.gray": "خاکستری",
  "item.minecraft.firework_star.green": "سبز",
  "item.minecraft.firework_star.light_blue": "آبي آسماني",
  "item.minecraft.firework_star.light_gray": "خاکستری روشن",
  "item.minecraft.firework_star.lime": "فسفري",
  "item.minecraft.firework_star.magenta": "فيروزه اي",
  "item.minecraft.firework_star.orange": "نارنجی",
  "item.minecraft.firework_star.pink": "صورتی",
  "item.minecraft.firework_star.purple": "بنفش",
  "item.minecraft.firework_star.red": "قرمز",
  "item.minecraft.firework_star.shape": "شکل نامعلوم",
  "item.minecraft.firework_star.shape.burst": "انفجار",
  "item.minecraft.firework_star.shape.creeper": "ترسانک شکل",
  "item.minecraft.firework_star.shape.large_ball": "گلوله بزرگ",
  "item.minecraft.firework_star.shape.small_ball": "گلوله کوچک",
  "item.minecraft.firework_star.shape.star": "ستاره شکل",
  "item.minecraft.firework_star.trail": "دنباله",
  "item.minecraft.firework_star.white": "سفيد",
  "item.minecraft.firework_star.yellow": "زرد",
  "item.minecraft.fishing_rod": "چوب ماهيگيري",
  "item.minecraft.flint": "سنگ چخماق",
  "item.minecraft.flint_and_steel": "آتش زنه",
  "item.minecraft.flow_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.flow_armor_trim_smithing_template.new": "تراش زره طرح جريان",
  "item.minecraft.flow_banner_pattern": "طرح بنر",
  "item.minecraft.flow_banner_pattern.desc": "جريان",
  "item.minecraft.flow_banner_pattern.new": "طرح بنر جريان",
  "item.minecraft.flow_pottery_sherd": "قطعه کوزه‌گری جريان",
  "item.minecraft.flower_banner_pattern": "طرح پرچم",
  "item.minecraft.flower_banner_pattern.desc": "گل شارژ",
  "item.minecraft.flower_banner_pattern.new": "طرح بنر گل",
  "item.minecraft.flower_pot": "گلدان",
  "item.minecraft.fox_spawn_egg": "تخم توليد روباه",
  "item.minecraft.friend_pottery_shard": "قطعه کوزه‌گری دوست",
  "item.minecraft.friend_pottery_sherd": "قطعه کوزه‌گری دوست",
  "item.minecraft.frog_spawn_egg": "تخم توليد قورباغه",
  "item.minecraft.furnace_minecart": "ماشين معدن با کوره",
  "item.minecraft.ghast_spawn_egg": "تخم توليد گَست",
  "item.minecraft.ghast_tear": "اشک گَست",
  "item.minecraft.glass_bottle": "بطری شيشه ای",
  "item.minecraft.glistering_melon_slice": "قاچ هندوانه درخشان",
  "item.minecraft.globe_banner_pattern": "طرح پرچم",
  "item.minecraft.globe_banner_pattern.desc": "کره",
  "item.minecraft.globe_banner_pattern.new": "طرح بنر دنيا",
  "item.minecraft.glow_berries": "توت درخشان",
  "item.minecraft.glow_ink_sac": "مرکب درخشان",
  "item.minecraft.glow_item_frame": "قاب آيتم درخشان",
  "item.minecraft.glow_squid_spawn_egg": "تخم تولید ماهی مرکب نورانی",
  "item.minecraft.glowstone_dust": "گرد روشنا",
  "item.minecraft.goat_horn": "شاخ بُز",
  "item.minecraft.goat_spawn_egg": "تخم توليد بُز",
  "item.minecraft.gold_ingot": "شمش طلا",
  "item.minecraft.gold_nugget": "ذره طلا",
  "item.minecraft.golden_apple": "سيب طلايی",
  "item.minecraft.golden_axe": "تبر طلايي",
  "item.minecraft.golden_boots": "چکمه طلايی",
  "item.minecraft.golden_carrot": "هويج طلايی",
  "item.minecraft.golden_chestplate": "زره طلايی",
  "item.minecraft.golden_helmet": "کلاهخود طلايی",
  "item.minecraft.golden_hoe": "خيش طلايی",
  "item.minecraft.golden_horse_armor": "زره طلايی اسب",
  "item.minecraft.golden_leggings": "شلوار طلايی",
  "item.minecraft.golden_nautilus_armor": "زره طلایی ملوانک",
  "item.minecraft.golden_pickaxe": "کلنگ طلايي",
  "item.minecraft.golden_shovel": "بيل طلايی",
  "item.minecraft.golden_spear": "نیزه طلایی",
  "item.minecraft.golden_sword": "شمشير طلايي",
  "item.minecraft.gray_bundle": "بقچه خاکستری",
  "item.minecraft.gray_dye": "رنگ خاکستری",
  "item.minecraft.gray_harness": "افسار خاکستری",
  "item.minecraft.green_bundle": "بقچه سبز",
  "item.minecraft.green_dye": "رنگ سبز",
  "item.minecraft.green_harness": "افسار سبز",
  "item.minecraft.guardian_spawn_egg": "تخم توليد محافظ",
  "item.minecraft.gunpowder": "باروت",
  "item.minecraft.guster_banner_pattern": "طرح بنر",
  "item.minecraft.guster_banner_pattern.desc": "گاستر",
  "item.minecraft.guster_banner_pattern.new": "طرح بنر گاستر",
  "item.minecraft.guster_pottery_sherd": "قطعه کوزه‌گری گاستر",
  "item.minecraft.happy_ghast_spawn_egg": "تخم تولید گست خوشحال",
  "item.minecraft.harness": "افسار",
  "item.minecraft.heart_of_the_sea": "قلب دریا",
  "item.minecraft.heart_pottery_shard": "قطعه کوزه‌گری قلب",
  "item.minecraft.heart_pottery_sherd": "قطعه کوزه‌گری قلب",
  "item.minecraft.heartbreak_pottery_shard": "قطعه کوزه‌گری قلب شکسته",
  "item.minecraft.heartbreak_pottery_sherd": "قطعه کوزه‌گری قلب شکسته",
  "item.minecraft.hoglin_spawn_egg": "تخم توليد هوگلين",
  "item.minecraft.honey_bottle": "بطری عسل",
  "item.minecraft.honeycomb": "موم عسل",
  "item.minecraft.hopper_minecart": "ماشين معدن با قيف",
  "item.minecraft.horse_spawn_egg": "تخم توليد اسب",
  "item.minecraft.host_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.host_armor_trim_smithing_template.new": "تراش زره طرح ميزبان",
  "item.minecraft.howl_pottery_shard": "قطعه کوزه‌گری زوزه",
  "item.minecraft.howl_pottery_sherd": "قطعه کوزه‌گری زوزه",
  "item.minecraft.husk_spawn_egg": "تخم توليد هاسک",
  "item.minecraft.ink_sac": "مرکب",
  "item.minecraft.iron_axe": "تبر آهني",
  "item.minecraft.iron_boots": "چکمه آهنی",
  "item.minecraft.iron_chestplate": "زره آهنی",
  "item.minecraft.iron_golem_spawn_egg": "تخم توليد غول آهنی",
  "item.minecraft.iron_helmet": "کلاهخود آهنی",
  "item.minecraft.iron_hoe": "خيش آهنی",
  "item.minecraft.iron_horse_armor": "زره آهنی اسب",
  "item.minecraft.iron_ingot": "شمش آهن",
  "item.minecraft.iron_leggings": "شلوار آهنی",
  "item.minecraft.iron_nautilus_armor": "زره آهنی ملوانک",
  "item.minecraft.iron_nugget": "ذره آهن",
  "item.minecraft.iron_pickaxe": "کلنگ آهني",
  "item.minecraft.iron_shovel": "بيل آهنی",
  "item.minecraft.iron_spear": "نیزه آهنی",
  "item.minecraft.iron_sword": "شمشير آهني",
  "item.minecraft.item_frame": "قاب",
  "item.minecraft.jungle_boat": "قايق جنگلی",
  "item.minecraft.jungle_chest_boat": "قايق جنگلی با صندوقچه",
  "item.minecraft.knowledge_book": "کتاب دانش",
  "item.minecraft.lapis_lazuli": "لاجورد",
  "item.minecraft.lava_bucket": "سطل گدازه",
  "item.minecraft.lead": "قلاده",
  "item.minecraft.leather": "چرم",
  "item.minecraft.leather_boots": "کفش چرمی",
  "item.minecraft.leather_chestplate": "پيراهن چرمی",
  "item.minecraft.leather_helmet": "کلاه چرمی",
  "item.minecraft.leather_horse_armor": "زره چرمی اسب",
  "item.minecraft.leather_leggings": "شلوار چرمی",
  "item.minecraft.light_blue_bundle": "بقچه آبی روشن",
  "item.minecraft.light_blue_dye": "رنگ آبی آسمانی",
  "item.minecraft.light_blue_harness": "افسار آبی روشن",
  "item.minecraft.light_gray_bundle": "بقچه خاکستری روشن",
  "item.minecraft.light_gray_dye": "رنگ نقره‌ای",
  "item.minecraft.light_gray_harness": "افسار نقره‌ای",
  "item.minecraft.lime_bundle": "بقچه لیمویی",
  "item.minecraft.lime_dye": "رنگ سبز روشن",
  "item.minecraft.lime_harness": "افسار سبز روشن",
  "item.minecraft.lingering_potion": "معجون ماندگار",
  "item.minecraft.lingering_potion.effect.awkward": "معجون ماندگار ناخوشايند",
  "item.minecraft.lingering_potion.effect.empty": "معجون ماندگار غيرقابل ساخت",
  "item.minecraft.lingering_potion.effect.fire_resistance": "معجون ماندگار ضد آتش",
  "item.minecraft.lingering_potion.effect.harming": "معجون ماندگار آسيب‌زننده",
  "item.minecraft.lingering_potion.effect.healing": "معجون ماندگار احیاء سلامتی",
  "item.minecraft.lingering_potion.effect.infested": "معجون ماندگار آفت زدن",
  "item.minecraft.lingering_potion.effect.invisibility": "معجون ماندگار نامرئي شدن",
  "item.minecraft.lingering_potion.effect.leaping": "معجون ماندگار پرش بلند",
  "item.minecraft.lingering_potion.effect.levitation": "معجون ماندگار شناوری",
  "item.minecraft.lingering_potion.effect.luck": "معجون ماندگار شانس",
  "item.minecraft.lingering_potion.effect.mundane": "معجون ماندگار گَرد دار",
  "item.minecraft.lingering_potion.effect.night_vision": "معجون ماندگار ديد در شب",
  "item.minecraft.lingering_potion.effect.oozing": "معجون جان تراوُش",
  "item.minecraft.lingering_potion.effect.poison": "معجون ماندگار سَم",
  "item.minecraft.lingering_potion.effect.regeneration": "معجون ماندگار ترميم",
  "item.minecraft.lingering_potion.effect.slow_falling": "معجون ماندگار سقوط آرام",
  "item.minecraft.lingering_potion.effect.slowness": "معجون ماندگار کندی",
  "item.minecraft.lingering_potion.effect.strength": "معجون ماندگار قدرت",
  "item.minecraft.lingering_potion.effect.swiftness": "معجون ماندگار چابکی",
  "item.minecraft.lingering_potion.effect.thick": "معجون ماندگار غليظ",
  "item.minecraft.lingering_potion.effect.turtle_master": "معجون ماندگار ارباب لاک‌پشت‌ها",
  "item.minecraft.lingering_potion.effect.water": "بطری آب ماندگار",
  "item.minecraft.lingering_potion.effect.water_breathing": "معجون ماندگار تنفس زير آب",
  "item.minecraft.lingering_potion.effect.weakness": "معجون ماندگار ضعف",
  "item.minecraft.lingering_potion.effect.weaving": "معجون ماندگار درهم بافتن",
  "item.minecraft.lingering_potion.effect.wind_charged": "معجون ماندگار حمله بادی",
  "item.minecraft.llama_spawn_egg": "تخم توليد لاما",
  "item.minecraft.lodestone_compass": "قطب نمای سنگ مرتعش",
  "item.minecraft.mace": "گُرز",
  "item.minecraft.magenta_bundle": "بقچه ارغوانی",
  "item.minecraft.magenta_dye": "رنگ سرخابی",
  "item.minecraft.magenta_harness": "افسار ارغوانی",
  "item.minecraft.magma_cream": "توپ ماگما",
  "item.minecraft.magma_cube_spawn_egg": "تخم توليد مکعب ماگما",
  "item.minecraft.mangrove_boat": "قايق حرا",
  "item.minecraft.mangrove_chest_boat": "قايق حرا با صندوقچه",
  "item.minecraft.map": "نقشه خالی",
  "item.minecraft.melon_seeds": "بذر هندوانه",
  "item.minecraft.melon_slice": "قاچ هندوانه",
  "item.minecraft.milk_bucket": "سطل شير",
  "item.minecraft.minecart": "ماشين معدن",
  "item.minecraft.miner_pottery_shard": "قطعه کوزه‌گری معدن‌چی",
  "item.minecraft.miner_pottery_sherd": "قطعه کوزه‌گری معدن‌چی",
  "item.minecraft.mojang_banner_pattern": "طرح پرچم",
  "item.minecraft.mojang_banner_pattern.desc": "چيز",
  "item.minecraft.mojang_banner_pattern.new": "طرح بنر چيز",
  "item.minecraft.mooshroom_spawn_egg": "تخم توليد قاو",
  "item.minecraft.mourner_pottery_shard": "قطعه کوزه‌گری سوگوار",
  "item.minecraft.mourner_pottery_sherd": "قطعه کوزه‌گری سوگوار",
  "item.minecraft.mule_spawn_egg": "تخم توليد قاطر",
  "item.minecraft.mushroom_stew": "سوپ قارچ",
  "item.minecraft.music_disc_11": "ديسک موسيقی",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "ديسک موسيقی",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "ديسک موسيقی",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "ديسک موسيقی",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "ديسک موسيقی",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "ديسک موسيقی",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "ديسک موسيقی",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "ديسک موسيقی",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (جعبه موسیقی)",
  "item.minecraft.music_disc_far": "ديسک موسيقی",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "دیسک موسیقی",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "ديسک موسيقی",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "ديسک موسيقی",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "ديسک موسيقی",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "ديسک موسيقی",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "ديسک موسيقی",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "ديسک موسيقی",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "ديسک موسيقی",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "ديسک موسيقی",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "ديسک موسيقی",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "ديسک موسيقی",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "ديسک موسيقی",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "گوشت گوسفند خام",
  "item.minecraft.name_tag": "نام گذار",
  "item.minecraft.nautilus_shell": "صدف ملوانک",
  "item.minecraft.nautilus_spawn_egg": "تخم توليد ملوانک",
  "item.minecraft.nether_brick": "آجر ندر",
  "item.minecraft.nether_star": "ستاره ندر",
  "item.minecraft.nether_wart": "زگيل ندر",
  "item.minecraft.netherite_axe": "تبر ندرايت",
  "item.minecraft.netherite_boots": "چکمه ندرايت",
  "item.minecraft.netherite_chestplate": "زره ندرايت",
  "item.minecraft.netherite_helmet": "کلاه‌خود ندرايت",
  "item.minecraft.netherite_hoe": "خیش ندرايت",
  "item.minecraft.netherite_horse_armor": "زره ندرايت اسب",
  "item.minecraft.netherite_ingot": "شمش ندرايت",
  "item.minecraft.netherite_leggings": "شلوار ندرايت",
  "item.minecraft.netherite_nautilus_armor": "زره ملوانک ندرايت",
  "item.minecraft.netherite_pickaxe": "کلنگ ندرايت",
  "item.minecraft.netherite_scrap": "تکه ندرايت",
  "item.minecraft.netherite_shovel": "بیل ندرايت",
  "item.minecraft.netherite_spear": "نیزه ندرايت",
  "item.minecraft.netherite_sword": "شمشیر ندرايت",
  "item.minecraft.netherite_upgrade_smithing_template": "قالب آهنگری",
  "item.minecraft.netherite_upgrade_smithing_template.new": "ارتقاء به ندرايت",
  "item.minecraft.oak_boat": "قايق بلوط",
  "item.minecraft.oak_chest_boat": "قايق بلوط با صندوقچه",
  "item.minecraft.ocelot_spawn_egg": "تخم توليد پلنگ",
  "item.minecraft.ominous_bottle": "بطری بديُمن",
  "item.minecraft.ominous_trial_key": "کليد آزمون بديُمن",
  "item.minecraft.orange_bundle": "بقچه نارنجی",
  "item.minecraft.orange_dye": "رنگ نارنجی",
  "item.minecraft.orange_harness": "افسار نارنجی",
  "item.minecraft.painting": "تابلو نقاشی",
  "item.minecraft.pale_oak_boat": "قایق بلوط کمرنگ",
  "item.minecraft.pale_oak_chest_boat": "قایق بلوط کمرنگ با صندوقچه",
  "item.minecraft.panda_spawn_egg": "تخم توليد پاندا",
  "item.minecraft.paper": "کاغذ",
  "item.minecraft.parched_spawn_egg": "تخم توليد خشکيده",
  "item.minecraft.parrot_spawn_egg": "تخم توليد طوطی",
  "item.minecraft.phantom_membrane": "غشای شبح",
  "item.minecraft.phantom_spawn_egg": "تخم تولید شبح",
  "item.minecraft.pig_spawn_egg": "تخم توليد خوک",
  "item.minecraft.piglin_banner_pattern": "طرح پرچم",
  "item.minecraft.piglin_banner_pattern.desc": "پوزه",
  "item.minecraft.piglin_banner_pattern.new": "طرح بنر پوزه",
  "item.minecraft.piglin_brute_spawn_egg": "تخم توليد پيگلين وحشی",
  "item.minecraft.piglin_spawn_egg": "تخم توليد پيگلين",
  "item.minecraft.pillager_spawn_egg": "تخم توليد غارتگر",
  "item.minecraft.pink_bundle": "بقچه صورتی",
  "item.minecraft.pink_dye": "رنگ صورتی",
  "item.minecraft.pink_harness": "افسار صورتی",
  "item.minecraft.pitcher_plant": "گياه کوزه‌دار",
  "item.minecraft.pitcher_pod": "صفحه کشت گياه کوزه‌دار",
  "item.minecraft.plenty_pottery_shard": "قطعه کوزه‌گری گنجينه",
  "item.minecraft.plenty_pottery_sherd": "قطعه کوزه‌گری گنجينه",
  "item.minecraft.poisonous_potato": "سیب زمینی سمی",
  "item.minecraft.polar_bear_spawn_egg": "تخم توليد خرس قطبی",
  "item.minecraft.popped_chorus_fruit": "ميوه کُر پف کرده",
  "item.minecraft.porkchop": "گوشت خوک خام",
  "item.minecraft.potato": "سیب زمینی",
  "item.minecraft.potion": "معجون",
  "item.minecraft.potion.effect.awkward": "معجون ناخوشایند",
  "item.minecraft.potion.effect.empty": "معجون غيرقابل ساخت",
  "item.minecraft.potion.effect.fire_resistance": "معجون ضد آتش",
  "item.minecraft.potion.effect.harming": "معجون آسيب‌زننده",
  "item.minecraft.potion.effect.healing": "معجون سلامتی",
  "item.minecraft.potion.effect.infested": "معجون آفت زدن",
  "item.minecraft.potion.effect.invisibility": "معجون نامرئی شدن",
  "item.minecraft.potion.effect.leaping": "معجون پرش بلند",
  "item.minecraft.potion.effect.levitation": "معجون شناوری",
  "item.minecraft.potion.effect.luck": "معجون شانس",
  "item.minecraft.potion.effect.mundane": "معجون گَرد دار",
  "item.minecraft.potion.effect.night_vision": "معجون ديد در شب",
  "item.minecraft.potion.effect.oozing": "معجون تراوُش",
  "item.minecraft.potion.effect.poison": "معجون سَم",
  "item.minecraft.potion.effect.regeneration": "معجون ترميم",
  "item.minecraft.potion.effect.slow_falling": "معجون سقوط آرام",
  "item.minecraft.potion.effect.slowness": "معجون کندی",
  "item.minecraft.potion.effect.strength": "معجون قدرت",
  "item.minecraft.potion.effect.swiftness": "معجون چابکی",
  "item.minecraft.potion.effect.thick": "معجون غليظ",
  "item.minecraft.potion.effect.turtle_master": "معجون ارباب لاک‌پشت‌ها",
  "item.minecraft.potion.effect.water": "بطری آب",
  "item.minecraft.potion.effect.water_breathing": "معجون تنفس زير آب",
  "item.minecraft.potion.effect.weakness": "معجون ضعف",
  "item.minecraft.potion.effect.weaving": "معجون درهم بافتن",
  "item.minecraft.potion.effect.wind_charged": "معجون حمله بادی",
  "item.minecraft.pottery_shard_archer": "قطعه کوزه‌گری کماندار",
  "item.minecraft.pottery_shard_arms_up": "قطعه کوزه‌گری دستان بالا",
  "item.minecraft.pottery_shard_prize": "قطعه کوزه‌گری هديه",
  "item.minecraft.pottery_shard_skull": "قطعه کوزه‌گری جمجمه",
  "item.minecraft.powder_snow_bucket": "سطل پودر برف",
  "item.minecraft.prismarine_crystals": "کريستال منشور دريايی",
  "item.minecraft.prismarine_shard": "تکه منشور دريايی",
  "item.minecraft.prize_pottery_shard": "قطعه کوزه‌گری هديه",
  "item.minecraft.prize_pottery_sherd": "قطعه کوزه‌گری هديه",
  "item.minecraft.pufferfish": "ماهی بادکنکی",
  "item.minecraft.pufferfish_bucket": "سطل ماهی بادکنکی",
  "item.minecraft.pufferfish_spawn_egg": "تخم توليد ماهی بادکنکی",
  "item.minecraft.pumpkin_pie": "کيک کدو",
  "item.minecraft.pumpkin_seeds": "دانه کدوتنبل",
  "item.minecraft.purple_bundle": "بقچه بنفش",
  "item.minecraft.purple_dye": "رنگ بنفش",
  "item.minecraft.purple_harness": "افسار بنفش",
  "item.minecraft.quartz": "کوارتز ندر",
  "item.minecraft.rabbit": "گوشت خرگوش خام",
  "item.minecraft.rabbit_foot": "پای خرگوش",
  "item.minecraft.rabbit_hide": "پوست خرگوش",
  "item.minecraft.rabbit_spawn_egg": "تخم توليد خرگوش",
  "item.minecraft.rabbit_stew": "خورش خرگوش",
  "item.minecraft.raiser_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "تراش زره طرح برافرازنده",
  "item.minecraft.ravager_spawn_egg": "تخم توليد نابودگر",
  "item.minecraft.raw_copper": "مس خام",
  "item.minecraft.raw_gold": "طلای خام",
  "item.minecraft.raw_iron": "آهن خام",
  "item.minecraft.recovery_compass": "قطب نمای بازيابی",
  "item.minecraft.red_bundle": "بقچه قرمز",
  "item.minecraft.red_dye": "رنگ قرمز",
  "item.minecraft.red_harness": "افسار قرمز",
  "item.minecraft.redstone": "گَرد ردستون",
  "item.minecraft.resin_brick": "آجر صمغ",
  "item.minecraft.resin_clump": "قپه صمغ",
  "item.minecraft.rib_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.rib_armor_trim_smithing_template.new": "تراش زره طرح شيار",
  "item.minecraft.rotten_flesh": "گوشت زامبي",
  "item.minecraft.saddle": "زين",
  "item.minecraft.salmon": "ماهی سالمون خام",
  "item.minecraft.salmon_bucket": "سطل ماهی سالمون",
  "item.minecraft.salmon_spawn_egg": "تخم توليد ماهی سالمون",
  "item.minecraft.scrape_pottery_sherd": "قطعه کوزه‌گری خراش",
  "item.minecraft.scute": "سپرچه",
  "item.minecraft.sentry_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "تراش زره طرح دژبان",
  "item.minecraft.shaper_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "تراش زره طرح شکل دهنده",
  "item.minecraft.sheaf_pottery_shard": "قطعه کوزه‌گری دسته‌گياه",
  "item.minecraft.sheaf_pottery_sherd": "قطعه کوزه‌گری دسته‌گياه",
  "item.minecraft.shears": "قيچی",
  "item.minecraft.sheep_spawn_egg": "تخم توليد گوسفند",
  "item.minecraft.shelter_pottery_shard": "قطعه کوزه‌گری پناهگاه",
  "item.minecraft.shelter_pottery_sherd": "قطعه کوزه‌گری پناهگاه",
  "item.minecraft.shield": "سپر",
  "item.minecraft.shield.black": "سپر سياه",
  "item.minecraft.shield.blue": "سپر آبی",
  "item.minecraft.shield.brown": "سپر قهوه‌ای",
  "item.minecraft.shield.cyan": "سپر فيروزه‌ای",
  "item.minecraft.shield.gray": "سپر خاکستری",
  "item.minecraft.shield.green": "سپر سبز",
  "item.minecraft.shield.light_blue": "سپر آبی روشن",
  "item.minecraft.shield.light_gray": "سپر خاکستری روشن",
  "item.minecraft.shield.lime": "سپر سبز روشن",
  "item.minecraft.shield.magenta": "سپر ارغوانی",
  "item.minecraft.shield.orange": "سپر نارنجی",
  "item.minecraft.shield.pink": "سپر صورتی",
  "item.minecraft.shield.purple": "سپر بنفش",
  "item.minecraft.shield.red": "سپر قرمز",
  "item.minecraft.shield.white": "سپر سفيد",
  "item.minecraft.shield.yellow": "سپر زرد",
  "item.minecraft.shulker_shell": "صدف شالکر",
  "item.minecraft.shulker_spawn_egg": "تخم توليد شالکر",
  "item.minecraft.sign": "تابلو",
  "item.minecraft.silence_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.silence_armor_trim_smithing_template.new": "تراش زره طرح سکوت",
  "item.minecraft.silverfish_spawn_egg": "تخم توليد سيلورفيش",
  "item.minecraft.skeleton_horse_spawn_egg": "تخم توليد اسب اسکلتی",
  "item.minecraft.skeleton_spawn_egg": "تخم توليد اسکلت",
  "item.minecraft.skull_banner_pattern": "طرح پرچم",
  "item.minecraft.skull_banner_pattern.desc": "جمجمه شارژ",
  "item.minecraft.skull_banner_pattern.new": "طرح بنر جمجمه",
  "item.minecraft.skull_pottery_shard": "قطعه کوزه‌گری جمجمه",
  "item.minecraft.skull_pottery_sherd": "قطعه کوزه‌گری جمجمه",
  "item.minecraft.slime_ball": "توپ لجن",
  "item.minecraft.slime_spawn_egg": "تخم توليد اسلايم",
  "item.minecraft.smithing_template": "قالب آهنگری",
  "item.minecraft.smithing_template.applies_to": "اعمال می‌شود روی:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "شمش يا کریستال بيافزاييد",
  "item.minecraft.smithing_template.armor_trim.applies_to": "زره",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "يک تکه از زره هايتان را بيافزاييد",
  "item.minecraft.smithing_template.armor_trim.ingredients": "شمش ها و کريستال ها",
  "item.minecraft.smithing_template.ingredients": "دستور های تهيه:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "شمش ندرايت بيافزاييد",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "تجهيزات الماسی",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "زره، اسلحه يا وسيله الماسی بيافزاييد",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "شمش ندرايت",
  "item.minecraft.smithing_template.upgrade": "ارتقاء: ",
  "item.minecraft.sniffer_spawn_egg": "تخم توليد بويشگر",
  "item.minecraft.snort_pottery_shard": "قطعه کوزه‌گری پوزه",
  "item.minecraft.snort_pottery_sherd": "قطعه کوزه‌گری پوزه",
  "item.minecraft.snout_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.snout_armor_trim_smithing_template.new": "تراش زره طرح پوزه",
  "item.minecraft.snow_golem_spawn_egg": "تخم توليد غول برفی",
  "item.minecraft.snowball": "گوله برفي",
  "item.minecraft.spectral_arrow": "تير نشانگر",
  "item.minecraft.spider_eye": "چشم عنکبوت",
  "item.minecraft.spider_spawn_egg": "تخم توليد عنکبوت",
  "item.minecraft.spire_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.spire_armor_trim_smithing_template.new": "تراش زره طرح مارپيچ",
  "item.minecraft.splash_potion": "معجون پرتابی",
  "item.minecraft.splash_potion.effect.awkward": "معجون ناخوشايند پرتابی",
  "item.minecraft.splash_potion.effect.empty": "معجون پرتابی غيرقابل ساخت",
  "item.minecraft.splash_potion.effect.fire_resistance": "معجون پرتابی ضد آتش",
  "item.minecraft.splash_potion.effect.harming": "معجون پرتابی آسيب‌زننده",
  "item.minecraft.splash_potion.effect.healing": "معجون پرتابی احیاء سلامتی",
  "item.minecraft.splash_potion.effect.infested": "معجون پرتابی آفت زدن",
  "item.minecraft.splash_potion.effect.invisibility": "معجون پرتابی نامرئي شدن",
  "item.minecraft.splash_potion.effect.leaping": "معجون پرتابی پرش بلند",
  "item.minecraft.splash_potion.effect.levitation": "معجون پرتابی شناوری",
  "item.minecraft.splash_potion.effect.luck": "معجون پرتابی شانس",
  "item.minecraft.splash_potion.effect.mundane": "معجون معجون گَرد دار پرتابی",
  "item.minecraft.splash_potion.effect.night_vision": "معجون پرتابی ديد در شب",
  "item.minecraft.splash_potion.effect.oozing": "معجون پرتابی تراوُش",
  "item.minecraft.splash_potion.effect.poison": "معجون پرتابی سَم",
  "item.minecraft.splash_potion.effect.regeneration": "معجون پرتابی ترميم",
  "item.minecraft.splash_potion.effect.slow_falling": "معجون پرتابی سقوط آرام",
  "item.minecraft.splash_potion.effect.slowness": "معجون پرتابی کندی",
  "item.minecraft.splash_potion.effect.strength": "معجون پرتابی قدرت",
  "item.minecraft.splash_potion.effect.swiftness": "معجون پرتابی چابکی",
  "item.minecraft.splash_potion.effect.thick": "معجون غليظ پرتابی",
  "item.minecraft.splash_potion.effect.turtle_master": "معجون پرتابی ارباب لاک‌پشت‌ها",
  "item.minecraft.splash_potion.effect.water": "بطری آب پرتابی",
  "item.minecraft.splash_potion.effect.water_breathing": "معجون پرتابی تنفس زير آب",
  "item.minecraft.splash_potion.effect.weakness": "معجون پرتابی ضعف",
  "item.minecraft.splash_potion.effect.weaving": "معجون پرتابی درهم بافتن",
  "item.minecraft.splash_potion.effect.wind_charged": "معجون پرتابی حمله بادی",
  "item.minecraft.spruce_boat": "قايق کاج",
  "item.minecraft.spruce_chest_boat": "قايق کاج با صندوقچه",
  "item.minecraft.spyglass": "تلسکوپ",
  "item.minecraft.squid_spawn_egg": "تخم توليد ماهی مرکب",
  "item.minecraft.stick": "تيکه چوب",
  "item.minecraft.stone_axe": "تبر سنگي",
  "item.minecraft.stone_hoe": "خيش سنگی",
  "item.minecraft.stone_pickaxe": "کلنگ سنگي",
  "item.minecraft.stone_shovel": "بيل سنگی",
  "item.minecraft.stone_spear": "نیزه سنگی",
  "item.minecraft.stone_sword": "شمشير سنگی",
  "item.minecraft.stray_spawn_egg": "تخم توليد استری",
  "item.minecraft.strider_spawn_egg": "تخم توليد قدم‌زن",
  "item.minecraft.string": "رشته",
  "item.minecraft.sugar": "شکر",
  "item.minecraft.suspicious_stew": "سوپ مشکوک",
  "item.minecraft.sweet_berries": "توت شيرين",
  "item.minecraft.tadpole_bucket": "سطل بچه قورباغه",
  "item.minecraft.tadpole_spawn_egg": "تخم توليد بچه قورباغه",
  "item.minecraft.tide_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.tide_armor_trim_smithing_template.new": "تراش زره طرح مواج",
  "item.minecraft.tipped_arrow": "تير آغشته‌شده",
  "item.minecraft.tipped_arrow.effect.awkward": "تير آغشته‌شده",
  "item.minecraft.tipped_arrow.effect.empty": "تير آغشته‌شده غیرقابل ساخت",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "تير مقاومت در برابر آتش",
  "item.minecraft.tipped_arrow.effect.harming": "تير آسيب‌زننده",
  "item.minecraft.tipped_arrow.effect.healing": "تير شفاعت",
  "item.minecraft.tipped_arrow.effect.infested": "تير آفت زننده",
  "item.minecraft.tipped_arrow.effect.invisibility": "تير نامرئي شدن",
  "item.minecraft.tipped_arrow.effect.leaping": "تير پرش بلند",
  "item.minecraft.tipped_arrow.effect.levitation": "تير شناوری",
  "item.minecraft.tipped_arrow.effect.luck": "تير شانس",
  "item.minecraft.tipped_arrow.effect.mundane": "تير آغشته‌شده",
  "item.minecraft.tipped_arrow.effect.night_vision": "تير دید در شب",
  "item.minecraft.tipped_arrow.effect.oozing": "تير تراوُش",
  "item.minecraft.tipped_arrow.effect.poison": "تير سَم",
  "item.minecraft.tipped_arrow.effect.regeneration": "تير احیاء کننده",
  "item.minecraft.tipped_arrow.effect.slow_falling": "تير سقوط آرام",
  "item.minecraft.tipped_arrow.effect.slowness": "تير کندی",
  "item.minecraft.tipped_arrow.effect.strength": "تير قدرت",
  "item.minecraft.tipped_arrow.effect.swiftness": "تير چابکی",
  "item.minecraft.tipped_arrow.effect.thick": "تير آغشته‌شده",
  "item.minecraft.tipped_arrow.effect.turtle_master": "تير ارباب لاک‌پشت‌ها",
  "item.minecraft.tipped_arrow.effect.water": "تير از هم پاشیدن",
  "item.minecraft.tipped_arrow.effect.water_breathing": "تير تنفس زير آب",
  "item.minecraft.tipped_arrow.effect.weakness": "تير ضعف",
  "item.minecraft.tipped_arrow.effect.weaving": "تير درهم بافتن",
  "item.minecraft.tipped_arrow.effect.wind_charged": "تير حمله بادی",
  "item.minecraft.tnt_minecart": "ماشين معدن با تي ان تي",
  "item.minecraft.torchflower_seeds": "دانه گل مشعلی",
  "item.minecraft.totem_of_undying": "مجسمه زد مرگ",
  "item.minecraft.trader_llama_spawn_egg": "تخم توليد لاما معامله‌گر",
  "item.minecraft.trial_key": "کليد آزمايش",
  "item.minecraft.trident": "چنگک",
  "item.minecraft.tropical_fish": "ماهی استوايی",
  "item.minecraft.tropical_fish_bucket": "سطل ماهی استوايی",
  "item.minecraft.tropical_fish_spawn_egg": "تخم توليد ماهی استوايی",
  "item.minecraft.turtle_helmet": "لاک لاکپشت",
  "item.minecraft.turtle_scute": "پوسته لاک پشت",
  "item.minecraft.turtle_spawn_egg": "تخم توليد لاکپشت",
  "item.minecraft.vex_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.vex_armor_trim_smithing_template.new": "تراش زره طرح وِکس",
  "item.minecraft.vex_spawn_egg": "تخم توليد وِکس",
  "item.minecraft.villager_spawn_egg": "تخم توليد روستايی",
  "item.minecraft.vindicator_spawn_egg": "تخم توليد کينه‌ورز",
  "item.minecraft.wandering_trader_spawn_egg": "تخم توليد معامله‌گر سرگردان",
  "item.minecraft.ward_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.ward_armor_trim_smithing_template.new": "تراش زره طرح نگهبان",
  "item.minecraft.warden_spawn_egg": "تخم توليد نگهبان",
  "item.minecraft.warped_fungus_on_a_stick": "قارچ پيچ‌خورده روی قلاب",
  "item.minecraft.water_bucket": "سطل آب",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "تراش زره طرح راه‌ياب",
  "item.minecraft.wheat": "گندم",
  "item.minecraft.wheat_seeds": "دانه های گندم",
  "item.minecraft.white_bundle": "بقچه سفيد",
  "item.minecraft.white_dye": "رنگ سفيد",
  "item.minecraft.white_harness": "افسار سفيد",
  "item.minecraft.wild_armor_trim_smithing_template": "قالب آهنگری",
  "item.minecraft.wild_armor_trim_smithing_template.new": "تراش زره طرح حيات وحش",
  "item.minecraft.wind_charge": "توپ باد",
  "item.minecraft.witch_spawn_egg": "تخم توليد جادوگر",
  "item.minecraft.wither_skeleton_spawn_egg": "تخم توليد اسکلت ويدر",
  "item.minecraft.wither_spawn_egg": "تخم توليد ويدر",
  "item.minecraft.wolf_armor": "زره پوش گرگ",
  "item.minecraft.wolf_spawn_egg": "تخم توليد گرگ",
  "item.minecraft.wooden_axe": "تبر چوبي",
  "item.minecraft.wooden_hoe": "خيش چوبی",
  "item.minecraft.wooden_pickaxe": "کلنگ چوبي",
  "item.minecraft.wooden_shovel": "بيل چوبی",
  "item.minecraft.wooden_spear": "نیزه چوبی",
  "item.minecraft.wooden_sword": "شمشير چوبي",
  "item.minecraft.writable_book": "کتاب و قلم",
  "item.minecraft.written_book": "کتاب نوشته شده",
  "item.minecraft.yellow_bundle": "بقچه زرد",
  "item.minecraft.yellow_dye": "رنگ زرد",
  "item.minecraft.yellow_harness": "افسار زرد",
  "item.minecraft.zoglin_spawn_egg": "تخم توليد زوگلين",
  "item.minecraft.zombie_horse_spawn_egg": "تخم توليد اسب زامبی",
  "item.minecraft.zombie_nautilus_spawn_egg": "تخم توليد ملوانک زامبی",
  "item.minecraft.zombie_spawn_egg": "تخم توليد زامبی",
  "item.minecraft.zombie_villager_spawn_egg": "تخم توليد زامبی روستايی",
  "item.minecraft.zombified_piglin_spawn_egg": "تخم توليد پيگلين زامبی شده"
}
export const fa_ir = items; 
